import axios from 'axios';

// Función para generar ID único para cada petición
//const generateRequestId = () => `req_${Date.now()}_${Math.floor(Math.random() * 1000)}`;
// ✅ SIMPLIFICAR requestId (solo para debugging crítico)
let requestCounter = 0;
const generateRequestId = () => ++requestCounter;

/**
 * Configuración para diferentes tamaños de conjuntos de datos
 * Adaptamos nuestra estrategia según el volumen total
 */
const getLoadingStrategy = (totalRecords) => {
    if (totalRecords < 5000) {
        // Conjuntos pequeños: carga estándar
        return {
            initialPageSize: 100,
            subsequentPageSize: 100,
            concurrentRequests: 5,
            prefetchPages: 2
        };
    } else if (totalRecords < 20000) {
        // Conjuntos medianos: aumentamos tamaño de página
        return {
            initialPageSize: 100,
            subsequentPageSize: 2000,
            concurrentRequests: 5,
            prefetchPages: 1
        };
    } else if (totalRecords < 100000) {
        // Conjuntos grandes: optimizamos para rendimiento
        return {
            initialPageSize: 100,
            subsequentPageSize: 10000,
            concurrentRequests: 5,
            prefetchPages: 1
        };
    } else if (totalRecords < 200000) {
        // Conjuntos grandes: optimizamos para rendimiento
        return {
            initialPageSize: 100,
            subsequentPageSize: 20000,
            concurrentRequests: 5,
            prefetchPages: 0
        };
    } else if (totalRecords < 400000) {
        // Conjuntos grandes: optimizamos para rendimiento
        return {
            initialPageSize: 100,
            subsequentPageSize: 10000,
            concurrentRequests: 5,
            prefetchPages: 0
        };
    } else if (totalRecords < 500000) {
        // Conjuntos grandes: optimizamos para rendimiento
        return {
            initialPageSize: 100,
            subsequentPageSize: 10000,
            concurrentRequests: 5,
            prefetchPages: 0
        };
    } else if (totalRecords < 1000000) {
        // Conjuntos grandes: optimizamos para rendimiento
        return {
            initialPageSize: 100,
            subsequentPageSize: 10000,
            concurrentRequests: 8,
            prefetchPages: 0
        };
    }
    else {
        // Conjuntos masivos: máxima eficiencia
        return {
            initialPageSize: 100,
            subsequentPageSize: 2000,
            concurrentRequests: 15,
            prefetchPages: 0 // Solo cargamos lo que se necesita
        };
    }
};

/**
 * Primera carga optimizada para mostrar datos rápidamente
 * Siempre usamos un tamaño de página pequeño para reducir el tiempo inicial
 */
const obtenerPrimerCarga = async (apiUrl, filtros, paginador) => {
    const requestId = generateRequestId();
    try {
        //console.log("Iniciando primera carga con página de 100 registros");

        //console.log(`🔄 [${requestId}] PETICIÓN INICIAL al endpoint: ${apiUrl}`);
        //console.log(`📤 [${requestId}] Filtros enviados: ${JSON.stringify({
        //    ...filtros,
        //    page: 1,
        //    limit: 100,
        //    count: true
        //}, null, 2).substring(0, 20000)}...`); // Limitamos a 500 caracteres

        const startTime = performance.now();

        const response = await axios.post(apiUrl, {
            ...filtros,
            page: 1,
            limit: 100, // Primera carga siempre pequeña para mostrar datos rápido
            count: true
        }, {
            timeout: 60000,
            maxContentLength: 50 * 1024 * 1024,
            maxBodyLength: 50 * 1024 * 1024,
        });

        const endTime = performance.now();
        //console.log(`📥 [${requestId}] Respuesta recibida en ${Math.round(endTime - startTime)}ms`);

        let newData = [];
        let totalPages = 0;
        let totalRecordsFromAPI = 0;

        // Extraer datos según la estructura de la respuesta
        if (response.data.data && response.data.data.pagination) {
            // Estructura de alertas de cámara/IA
            newData = response.data.data.items || [];
            totalPages = response.data.data.pagination.lastPage;
            totalRecordsFromAPI = response.data.data.pagination.total;
        } else if (response.data.pagination) {
            // Estructura de alertas GPS
            newData = response.data.data || [];
            totalPages = response.data.pagination.lastPage;
            totalRecordsFromAPI = response.data.pagination.total;
        } else {
            // Estructura alternativa o fallback
            newData = response.data.data?.items || response.data.data || [];
            totalRecordsFromAPI = newData.length;
            totalPages = 1;
        }
        // if (response.data.pagination === undefined) {
        //     newData = response.data.data.items || [];
        //     totalPages = response.data.data.pagination.lastPage;
        //     totalRecordsFromAPI = response.data.data.pagination.total;
        // } else {
        //     newData = response.data.data || [];
        //     totalPages = response.data.pagination.lastPage;
        //     totalRecordsFromAPI = response.data.pagination.total;
        // }

        //console.log(`Total registros detectados: ${totalRecordsFromAPI}, páginas iniciales: ${totalPages}`);
        //console.log(`✅ [${requestId}] DATOS INICIALES: Recibidos ${newData.length} registros de ${totalRecordsFromAPI} totales`);
        //console.log(`📊 [${requestId}] Paginación: Página 1/${totalPages}, Tamaño: 100`);

        if (newData.length === 0) {
            console.warn(`⚠️ [${requestId}] ALERTA: Primera página sin datos!`);
        }

        // Actualizar el paginador con los datos iniciales
        paginador.editarTotalPaginas(totalPages);
        paginador.editarTotalDatos(totalRecordsFromAPI);
        paginador.editarDatos(newData);
        paginador.editarDatosCargados(newData.length);

        // Calcular progreso inicial
        const progress = Math.round((1 / totalPages) * 100);
        paginador.editarProgresoCargado(progress > 0 ? progress : 1);

        return {
            newData,
            totalPages,
            totalRecordsFromAPI,
            initialLoadSize: 100 // Retornamos el tamaño de página usado
        };
    } catch (error) {
        console.error(`❌ [${requestId}] ERROR en petición inicial: ${error.message}`);
        //console.error(`🔍 [${requestId}] Detalles: ${error.response ? JSON.stringify(error.response.data).substring(0, 200) : 'Sin detalles'}`);

        console.error("Error en carga inicial:", error);
        paginador.editarPaginasNoCargadas({
            id: requestId,
            pagina: 1,
            error: `[${requestId}] Error en petición inicial: ${error.message || error}`
        });

        // Retornar valores por defecto para evitar errores
        return {
            newData: [],
            totalPages: 0,
            totalRecordsFromAPI: 0,
            initialLoadSize: 100
        };
    }
};

/**
 * Sistema de caché para almacenar datos por rangos de páginas
 * Evita volver a cargar datos ya obtenidos
 */
class DataCache {
    constructor() {
        this.cache = new Map();
        this.MAX_CACHE_SIZE = 100; // Número máximo de rangos en caché
    }

    // Almacenar un rango de datos en la caché con clave mejorada
    storeRange(cacheId, apiUrl, filtros, startPage, endPage, pageSize, data) {
        // Generar hash de filtros para diferenciar consultas con mismos parámetros de paginación
        const filtrosHash = this._generateFilterHash(filtros);
        const key = `${cacheId}-${apiUrl}-${filtrosHash}-${startPage}-${endPage}-${pageSize}`;

        // Si la caché está llena, eliminar la entrada más antigua
        if (this.cache.size >= this.MAX_CACHE_SIZE) {
            const oldestKey = this.cache.keys().next().value;
            this.cache.delete(oldestKey);
        }

        this.cache.set(key, {
            data,
            timestamp: Date.now()
        });
    }

    // Verificar si un rango específico está en caché
    hasRange(cacheId, apiUrl, filtros, startPage, endPage, pageSize) {
        const filtrosHash = this._generateFilterHash(filtros);
        const key = `${cacheId}-${apiUrl}-${filtrosHash}-${startPage}-${endPage}-${pageSize}`;
        return this.cache.has(key);
    }

    // Obtener datos de un rango de la caché
    getRange(cacheId, apiUrl, filtros, startPage, endPage, pageSize) {
        const filtrosHash = this._generateFilterHash(filtros);
        const key = `${cacheId}-${apiUrl}-${filtrosHash}-${startPage}-${endPage}-${pageSize}`;
        const entry = this.cache.get(key);

        if (entry) {
            // Actualizar timestamp para marcar como recientemente usado
            entry.timestamp = Date.now();
            return entry.data;
        }

        return null;
    }

    // Generar un hash simple para los filtros
    _generateFilterHash(filtros) {
        // Crear una representación de string estable de los filtros
        // Esto diferenciará consultas con diferentes filtros
        try {
            const filtrosStr = JSON.stringify(filtros);
            // Crear un hash simple
            let hash = 0;
            for (let i = 0; i < filtrosStr.length; i++) {
                const char = filtrosStr.charCodeAt(i);
                hash = ((hash << 5) - hash) + char;
                hash = hash & hash; // Convertir a 32bit integer
            }
            return hash.toString(16); // Convertir a hex string
        } catch (e) {
            // Fallback en caso de error
            return Date.now().toString();
        }
    }

    // Limpiar caché completa
    clear() {
        this.cache.clear();
    }
}

// Crear instancia de caché global
const dataCache = new DataCache();

/**
 * Cargar rango de páginas con tamaño adaptativo - VERSIÓN MEJORADA
 * Optimizado para grandes volúmenes de datos
 */
const cargarRangoPaginas = async (apiUrl, filtros, startPage, endPage, pageSize, paginador, cacheId = 'default') => {
    // Verificar si el rango está en caché
    if (dataCache.hasRange(cacheId, apiUrl, filtros, startPage, endPage, pageSize)) {
        //console.log(`Usando caché para páginas ${startPage}-${endPage} (tamaño ${pageSize})`);
        const cachedData = dataCache.getRange(cacheId, apiUrl, filtros, startPage, endPage, pageSize);

        // AÑADIR ESTA VALIDACIÓN CRÍTICA:
        if (cachedData && Array.isArray(cachedData) && cachedData.length > 0) {
            //console.log(`Recuperados ${cachedData.length} registros de caché`);
            return cachedData;
        } else {
            //console.log(`Caché inválida o vacía para páginas ${startPage}-${endPage}, cargando desde API`);
        }
    }

    //console.log(`Cargando páginas ${startPage}-${endPage} con tamaño ${pageSize}`);
    const collectedData = [];
    const failedPages = [];

    // Configuración para reintentos
    const maxRetries = 3;
    const retryDelays = [1000, 3000, 7000]; // Backoff exponencial

    // Función mejorada con reintentos
    const fetchPageWithRetry = async (page, retryCount = 0) => {
        const requestId = generateRequestId();


        try {

            //console.log(`🔄 [${requestId}] Solicitando página ${page} (tamaño: ${pageSize})`);

            //const filtrosResumen = Object.keys(filtros).reduce((acc, key) => {
            //    // Resumir arrays largos
            //    if (Array.isArray(filtros[key]) && filtros[key].length > 3) {
            //        acc[key] = `[${filtros[key].length} elementos]`;
            //    } else {
            //        acc[key] = filtros[key];
            //    }
            //    return acc;
            //}, {});

            //console.log(`📤 [${requestId}] Filtros para página ${page}: ${JSON.stringify({
            //    ...filtrosResumen,
            //    page,
            //    limit: pageSize
            //}).substring(0, 1500)}...`);


            const startTime = performance.now();
            const response = await axios.post(apiUrl, {
                ...filtros,
                page: page,
                limit: pageSize,
                count: false
            }, {
                timeout: 60000,
                maxContentLength: 50 * 1024 * 1024,
                maxBodyLength: 50 * 1024 * 1024,
            });
            const endTime = performance.now();

            //console.log(`📥 [${requestId}] Página ${page} recibida en ${Math.round(endTime - startTime)}ms`);


            let pageData = [];
            if (response.data.pagination === undefined) {
                pageData = response.data.data.items || [];
            } else {
                pageData = response.data.data || [];
            }

            //console.log(`✅ [${requestId}] Página ${page}: ${pageData.length} registros recibidos`);

            if (pageData.length === 0) {
                console.warn(`⚠️ [${requestId}] ALERTA: Página ${page} vacía!`);
            }

            return { success: true, page, data: pageData };
        } catch (error) {
            console.error(`❌ [${requestId}] ERROR en página ${page}: ${error.message}`);

            if (error.response) {
                //console.error(`🔍 [${requestId}] Status: ${error.response.status}, Datos: ${JSON.stringify(error.response.data).substring(0, 200)}`);
            }

            // Intentar de nuevo si no superamos el máximo de reintentos
            if (retryCount < maxRetries) {
                console.log(`🔁 [${requestId}] Reintentando página ${page} (intento ${retryCount + 1}/${maxRetries})`);
                await new Promise(resolve => setTimeout(resolve, retryDelays[retryCount]));
                return fetchPageWithRetry(page, retryCount + 1);
            }

            paginador.editarPaginasNoCargadas({
                id: requestId,
                pagina: page,
                error: `[${requestId}] Error en página ${page}: ${error.message || error}`
            });

            return { success: false, page, error };
        }
    };

    // Usar un enfoque de "lotes" para controlar memoria y concurrencia
    const BATCH_SIZE = 5; // Número de páginas a procesar en paralelo

    for (let batchStart = startPage; batchStart <= endPage; batchStart += BATCH_SIZE) {
        const batchEnd = Math.min(batchStart + BATCH_SIZE - 1, endPage);
        const batchPromises = [];

        // Preparar las promesas del lote actual
        for (let page = batchStart; page <= batchEnd; page++) {
            batchPromises.push(fetchPageWithRetry(page));
        }

        // Ejecutar en paralelo las peticiones del lote actual
        const results = await Promise.all(batchPromises);

        // Procesar resultados
        results.forEach(result => {
            if (result.success) {
                collectedData.push(...result.data);
            } else {
                failedPages.push(result.page);
            }
        });

        // Pequeña pausa entre lotes para mantener responsividad del navegador
        if (batchEnd < endPage) {
            await new Promise(resolve => setTimeout(resolve, 50));
        }
    }

    // Reintentar páginas fallidas una última vez
    if (failedPages.length > 0) {
        //console.log(`Reintentando ${failedPages.length} páginas fallidas una última vez`);

        const recoveryPromises = failedPages.map(page => fetchPageWithRetry(page, 1));
        const recoveryResults = await Promise.all(recoveryPromises);

        // Añadir datos recuperados
        recoveryResults.forEach(result => {
            if (result.success) {
                collectedData.push(...result.data);
            }
        });
    }

    // Almacenar en caché para futuras consultas
    if (collectedData && collectedData.length > 0) {
        //console.log(`Guardando ${collectedData.length} registros en caché para páginas ${startPage}-${endPage}`);
        dataCache.storeRange(cacheId, apiUrl, filtros, startPage, endPage, pageSize, collectedData);
    }

    return collectedData;
};

/**
 * Primera carga minimalista - Solo para obtener metadatos
 * Optimizado para velocidad de respuesta
 */
const obtenerMetadatos_RS01062025 = async (apiUrl, filtros, paginador) => {
    const requestId = generateRequestId();
    try {
        //console.log("Obteniendo metadatos de paginación (carga mínima)");

        //console.log(`🔄 [${requestId}] PETICIÓN INICIAL MÍNIMA al endpoint: ${apiUrl}`);

        const startTime = performance.now();
        const response = await axios.post(apiUrl, {
            ...filtros,
            page: 1,
            limit: 1, // Solo pedimos 1 registro para tener metadatos
            count: true
        }, {
            timeout: 60000,
            maxContentLength: 50 * 1024 * 1024,
            maxBodyLength: 50 * 1024 * 1024,
        });
        const endTime = performance.now();

        //console.log(`📥 [${requestId}] Metadatos recibidos en ${Math.round(endTime - startTime)}ms`);

        // Verificar si hay un código de error en la respuesta
        if (response.data && response.data.statusCode && response.data.statusCode !== 200) {
            const errorMessage = response.data.message || 'Error en la solicitud';
            console.error(`❌ [${requestId}] Error de API: ${errorMessage} (código: ${response.data.statusCode})`);

            paginador.editarError(errorMessage);
            paginador.editarCargando(false);

            return {
                totalPages: 0,
                totalRecordsFromAPI: 0,
                error: true,
                errorMessage: errorMessage
            };
        }

        if (response.data && response.data.success === false) {
            const errorMessage = response.data.message || 'Error en la solicitud';
            console.error(`❌ [${requestId}] Error de API: ${errorMessage}`);

            paginador.editarError(errorMessage);
            paginador.editarCargando(false);

            return {
                totalPages: 0,
                totalRecordsFromAPI: 0,
                error: true,
                errorMessage: errorMessage
            };
        }

        // Extraer metadatos según la estructura de la respuesta
        let totalPages = 0;
        let totalRecordsFromAPI = 0;

        // Versión más robusta para manejar diferentes estructuras
        if (response.data) {
            // Estructura de alertas de cámara/IA
            if (response.data.data && response.data.data.pagination) {
                totalPages = response.data.data.pagination.lastPage || 0;
                totalRecordsFromAPI = response.data.data.pagination.total || 0;
            }
            // Estructura de alertas GPS
            else if (response.data.pagination) {
                totalPages = response.data.pagination.lastPage || 0;
                totalRecordsFromAPI = response.data.pagination.total || 0;
            }
            // Estructura alternativa
            else if (response.data.data && response.data.data.count) {
                totalRecordsFromAPI = response.data.data.count || 0;
                totalPages = Math.ceil(totalRecordsFromAPI / (filtros.limit || 100));
            }
            // Fallback - si solo hay items pero no paginación
            else if (response.data.data && Array.isArray(response.data.data.items)) {
                totalRecordsFromAPI = response.data.data.items.length;
                totalPages = 1;
            }
        }

        //console.log(`✅ [${requestId}] METADATOS: Total ${totalRecordsFromAPI} registros en ${totalPages} páginas`);

        // Actualizar el paginador solo con la información de paginación
        paginador.editarTotalPaginas(totalPages);
        paginador.editarTotalDatos(totalRecordsFromAPI);

        return {
            totalPages,
            totalRecordsFromAPI,
            error: false
        };
    } catch (error) {
        console.error(`❌ [${requestId}] ERROR en petición de metadatos: ${error.message}`);

        // Capturar mensaje de error desde la respuesta API si está disponible
        let errorMessage = error.message || 'Error en petición de metadatos';
        if (error.response && error.response.data && error.response.data.message) {
            errorMessage = error.response.data.message;
        }

        paginador.editarPaginasNoCargadas({
            id: requestId,
            pagina: 1,
            error: `[${requestId}] ${errorMessage}`
        });

        paginador.editarError(errorMessage);
        paginador.editarCargando(false);

        // Retornar valores por defecto para evitar errores
        return {
            totalPages: 0,
            totalRecordsFromAPI: 0,
            error: true,
            errorMessage: errorMessage
        };
    }
};


const obtenerMetadatos = async (apiUrl, filtros, paginador) => {
    const requestId = generateRequestId();
    try {
        //console.log("Obteniendo metadatos de paginación (carga mínima)");

        //console.log(`🔄 [${requestId}] PETICIÓN INICIAL MÍNIMA al endpoint: ${apiUrl}`);

        // ✅ ELIMINAR LIMIT DE LOS FILTROS PARA QUE RESPETE EL DEFAULT DE 1
        const { limit, ...filtrosSinLimit } = filtros;
        if (limit) {
            //console.log(`🔧 [${requestId}] Eliminando limit: ${limit} de filtros para usar limit: 1 por defecto`);
        }

        const startTime = performance.now();
        // Preparar y mostrar el payload antes de la petición
        const requestPayload = {
            ...filtrosSinLimit,
            page: 1,
            limit: 1,
            count: true
        };
        //console.log(`[${requestId}] Enviando metadatos con payload:`, JSON.stringify(requestPayload, null, 2));

        const response = await axios.post(apiUrl, requestPayload, {
            timeout: 60000,
            maxContentLength: 50 * 1024 * 1024,
            maxBodyLength: 50 * 1024 * 1024,
        });
        const endTime = performance.now();

        //console.log(`📥 [${requestId}] Metadatos recibidos en ${Math.round(endTime - startTime)}ms`);

        // ✅ VERIFICAR ERRORES EN MÚLTIPLES UBICACIONES DE LA RESPUESTA
        let errorMessage = null;

        // Caso 1: Error en response.data.error (como en tu ejemplo)
        if (response.data && response.data.error && response.data.error.message) {
            errorMessage = response.data.error.message;
        }

        // Caso 2: Error directo en response.data.message
        else if (response.data && response.data.message && response.data.success === false) {
            errorMessage = response.data.message;
        }
        // Caso 3: StatusCode diferente de 200
        else if (response.data && response.data.statusCode && response.data.statusCode !== 200) {
            errorMessage = response.data.message || 'Error en la solicitud';
        }

        if (response.data && response.data.success === false) {
            errorMessage = response.data.message || 'Error en la solicitud';
            console.error(`❌ [${requestId}] Error de API: ${errorMessage}`);

            paginador.editarError(errorMessage);
            paginador.editarCargando(false);

            return {
                totalPages: 0,
                totalRecordsFromAPI: 0,
                error: true,
                errorMessage: errorMessage.trim() // Consistente con otros casos
            };
        }
        // Caso 4: Success = false
        // else if (response.data && response.data.success === false) {
        //     errorMessage = response.data.message || 'Error desconocido en la API';
        // }



        // ✅ SI HAY ERROR, PROCESARLO
        if (errorMessage) {
            console.error(`❌ [${requestId}] Error de API: ${errorMessage}`);

            paginador.editarError(errorMessage);
            paginador.editarCargando(false);

            return {
                totalPages: 0,
                totalRecordsFromAPI: 0,
                error: true,
                errorMessage: errorMessage.trim() // ✅ LIMPIAR ESPACIOS EN BLANCO
            };
        }

        // ✅ PROCESAR DATOS NORMALMENTE SI NO HAY ERROR
        let totalPages = 0;
        let totalRecordsFromAPI = 0;

        if (response.data) {
            // Estructura de alertas de cámara/IA
            if (response.data.data && response.data.data.pagination) {
                totalPages = response.data.data.pagination.lastPage || 0;
                totalRecordsFromAPI = response.data.data.pagination.total || 0;
            }
            // Estructura de alertas GPS
            else if (response.data.pagination) {
                totalPages = response.data.pagination.lastPage || 0;
                totalRecordsFromAPI = response.data.pagination.total || 0;
            }
            // Estructura alternativa
            else if (response.data.data && response.data.data.count) {
                totalRecordsFromAPI = response.data.data.count || 0;
                totalPages = Math.ceil(totalRecordsFromAPI / (filtros.limit || 100));
            }
            // Fallback - si solo hay items pero no paginación
            else if (response.data.data && Array.isArray(response.data.data.items)) {
                totalRecordsFromAPI = response.data.data.items.length;
                totalPages = 1;
            }
        }

        //console.log(`✅ [${requestId}] METADATOS: Total ${totalRecordsFromAPI} registros en ${totalPages} páginas`);

        paginador.editarTotalPaginas(totalPages);
        paginador.editarTotalDatos(totalRecordsFromAPI);

        return {
            totalPages,
            totalRecordsFromAPI,
            error: false
        };

    } catch (error) {
        console.error(`❌ [${requestId}] ERROR en petición de metadatos:`, error);

        // ✅ CAPTURAR MENSAJE DE ERROR DESDE RESPUESTA HTTP
        let errorMessage = 'Error en petición de metadatos';

        if (error.response && error.response.data) {
            // Caso 1: Error en response.data.error.message
            if (error.response.data.error && error.response.data.error.message) {
                errorMessage = `Error del servidor: ${error.response.data.error.message}`;

                // ✅ AGREGAR CONTEXTO ESPECÍFICO PARA TIMEOUT
                if (error.response.data.error.message.includes('ETIMEDOUT')) {
                    errorMessage = 'Error de conexión: Tiempo de espera agotado. El servidor no responde.';
                }
            }
            // Caso 2: Error directo en response.data.message
            else if (error.response.data.message) {
                errorMessage = error.response.data.message;
            }
            // Caso 3: Error en el status HTTP
            else if (error.response.status) {
                errorMessage = `Error HTTP ${error.response.status}: ${error.response.statusText || 'Error del servidor'}`;
            }
        } else if (error.message) {
            // Error de red, timeout, etc.
            if (error.message.includes('timeout')) {
                errorMessage = 'Error de conexión: Tiempo de espera agotado';
            } else if (error.message.includes('Network Error')) {
                errorMessage = 'Error de red: No se puede conectar al servidor';
            } else {
                errorMessage = error.message;
            }
        }

        paginador.editarPaginasNoCargadas({
            id: requestId,
            pagina: 1,
            error: `[${requestId}] ${errorMessage}`
        });

        paginador.editarError(errorMessage);
        paginador.editarCargando(false);

        return {
            totalPages: 0,
            totalRecordsFromAPI: 0,
            error: true,
            errorMessage: errorMessage.trim()
        };
    }
};

const obtenerMetadatos_respaldo = async (apiUrl, filtros, paginador) => {
    const requestId = generateRequestId();
    try {
        //console.log("Obteniendo metadatos de paginación (carga mínima)");

        console.log(`🔄 [${requestId}] PETICIÓN INICIAL MÍNIMA al endpoint: ${apiUrl}`);

        const startTime = performance.now();
        const response = await axios.post(apiUrl, {
            ...filtros,
            page: 1,
            limit: 1, // Solo pedimos 1 registro para tener metadatos
            count: true
        }, {
            timeout: 60000,
            maxContentLength: 50 * 1024 * 1024,
            maxBodyLength: 50 * 1024 * 1024,
        });
        const endTime = performance.now();

        console.log(`📥 [${requestId}] Metadatos recibidos en ${Math.round(endTime - startTime)}ms`);

        // Extraer metadatos según la estructura de la respuesta
        let totalPages = 0;
        let totalRecordsFromAPI = 0;

        // Versión más robusta para manejar diferentes estructuras
        if (response.data) {
            // Estructura de alertas de cámara/IA
            if (response.data.data && response.data.data.pagination) {
                totalPages = response.data.data.pagination.lastPage || 0;
                totalRecordsFromAPI = response.data.data.pagination.total || 0;
            }
            // Estructura de alertas GPS
            else if (response.data.pagination) {
                totalPages = response.data.pagination.lastPage || 0;
                totalRecordsFromAPI = response.data.pagination.total || 0;
            }
            // Estructura alternativa
            else if (response.data.data && response.data.data.count) {
                totalRecordsFromAPI = response.data.data.count || 0;
                totalPages = Math.ceil(totalRecordsFromAPI / (filtros.limit || 100));
            }
            // Fallback - si solo hay items pero no paginación
            else if (response.data.data && Array.isArray(response.data.data.items)) {
                totalRecordsFromAPI = response.data.data.items.length;
                totalPages = 1;
            }
        }

        //console.log(`✅ [${requestId}] METADATOS: Total ${totalRecordsFromAPI} registros en ${totalPages} páginas`);

        // Actualizar el paginador solo con la información de paginación
        paginador.editarTotalPaginas(totalPages);
        paginador.editarTotalDatos(totalRecordsFromAPI);

        return {
            totalPages,
            totalRecordsFromAPI
        };
    } catch (error) {
        console.error(`❌ [${requestId}] ERROR en petición de metadatos: ${error.message}`);

        paginador.editarPaginasNoCargadas({
            id: requestId,
            pagina: 1,
            error: `[${requestId}] Error en petición de metadatos: ${error.message || error}`
        });

        // Retornar valores por defecto para evitar errores
        return {
            totalPages: 0,
            totalRecordsFromAPI: 0
        };
    }
};

/**
 * Función principal mejorada para cargar datos con estrategia adaptativa - VERSIÓN OPTIMIZADA
 */
const cargarPaginas = async (apiUrl, paginador, filtros, cacheId = 'default', onPartialData = null) => {
    try {
        paginador.editarPaginaActual(1);
        paginador.editarCargando(true);
        paginador.editarCargaCompletada(false);
        paginador.editarDatos([]);
        paginador.editarProgresoCargado(0);

        //const { totalPages, totalRecordsFromAPI } = await obtenerMetadatos(apiUrl, filtros, paginador);
        const { totalPages, totalRecordsFromAPI, error, errorMessage } = await obtenerMetadatos(apiUrl, filtros, paginador);

        if (error) {
            if (typeof onPartialData === 'function') {
                onPartialData([], 0, errorMessage);
            }
            return;
        }

        if (totalRecordsFromAPI === 0) {
            paginador.editarCargaCompletada(true);
            paginador.editarCargando(false);
            return;
        }

        const strategy = getLoadingStrategy(totalRecordsFromAPI);
        const pageSize = strategy.subsequentPageSize;
        const pagesNeeded = Math.ceil(totalRecordsFromAPI / pageSize);

        let accumulatedData = [];

        // Carga por bloques, actualizando el paginador y llamando al callback en cada bloque
        const PARALLEL_BLOCKS = totalRecordsFromAPI > 50000 ? 3 : 5;
        const BLOCK_SIZE = Math.ceil(pagesNeeded / 10);

        const blocks = [];
        for (let page = 1; page <= pagesNeeded; page += BLOCK_SIZE) {
            const blockEndPage = Math.min(page + BLOCK_SIZE - 1, pagesNeeded);
            blocks.push({ startPage: page, endPage: blockEndPage });
        }

        for (let i = 0; i < blocks.length; i += PARALLEL_BLOCKS) {
            const currentBlocks = blocks.slice(i, i + PARALLEL_BLOCKS);
            const currentBlocksPromises = currentBlocks.map(block =>
                cargarRangoPaginas(apiUrl, filtros, block.startPage, block.endPage, pageSize, paginador, cacheId)
            );
            const blocksResults = await Promise.all(currentBlocksPromises);

            for (const blockData of blocksResults) {
                if (blockData && Array.isArray(blockData)) {
                    accumulatedData = [...accumulatedData, ...blockData];
                }
            }

            paginador.editarDatos(accumulatedData);
            paginador.editarDatosCargados(accumulatedData.length);

            const lastProcessedBlock = currentBlocks[currentBlocks.length - 1];
            const pagesProcessed = lastProcessedBlock.endPage;
            const progress = Math.round((pagesProcessed / pagesNeeded) * 100);
            paginador.editarProgresoCargado(progress);

            // Nuevo: callback para datos parciales
            if (typeof onPartialData === 'function') {
                onPartialData(accumulatedData, progress);
            }

            await new Promise(resolve => setTimeout(resolve, 100));
        }

        paginador.editarCargaCompletada(true);
        paginador.editarCargando(false);
        paginador.editarProgresoCargado(100);

    } catch (error) {
        console.error("Error global en carga de datos:", error);
        paginador.editarError(`Error en carga de datos: ${error.message || error}`);
        paginador.editarCargando(false);

        // Notificar error a través del callback
        if (typeof onPartialData === 'function') {
            onPartialData([], 0, error.message || "Error en carga de datos");
        }
    }
};

/**
 * Función para limpiar caché cuando ya no se necesita
 * (útil al cambiar de reportes o cerrar la aplicación)
 */
const limpiarCache = () => {
    dataCache.clear();
    //console.log("Caché de datos limpiada");
};



/**
 * Función principal mejorada con soporte para métricas en tiempo real
 */
const cargarPaginasConMetricas = async (apiUrl, paginador, filtros, cacheId = 'default', onPartialData = null, onMetricsUpdate = null) => {
    try {
        paginador.editarPaginaActual(1);
        paginador.editarCargando(true);
        paginador.editarCargaCompletada(false);
        paginador.editarDatos([]);
        paginador.editarProgresoCargado(0);

        const { totalPages, totalRecordsFromAPI, error, errorMessage } = await obtenerMetadatos(apiUrl, filtros, paginador);

        // ✅ REPORTAR TOTAL ESPERADO
        if (onMetricsUpdate) {
            const strategy = getLoadingStrategy(totalRecordsFromAPI);
            const pageSize = strategy.subsequentPageSize;
            const estimatedCalls = Math.ceil(totalRecordsFromAPI / pageSize);

            onMetricsUpdate({
                totalRecordsExpected: totalRecordsFromAPI,
                totalApiCalls: estimatedCalls
            });
        }

        if (error) {
            if (typeof onPartialData === 'function') {
                onPartialData([], 0, errorMessage);
            }
            return;
        }

        if (totalRecordsFromAPI === 0) {
            paginador.editarCargaCompletada(true);
            paginador.editarCargando(false);
            return;
        }

        const strategy = getLoadingStrategy(totalRecordsFromAPI);
        const pageSize = strategy.subsequentPageSize;
        const pagesNeeded = Math.ceil(totalRecordsFromAPI / pageSize);

        let accumulatedData = [];
        let completedCalls = 0;
        let failedCalls = 0;
        let recoveredCalls = 0;

        // ✅ FUNCIÓN PARA REPORTAR LLAMADA API
        const reportApiCall = (type, page, duration, success, recovered = false) => {
            if (onMetricsUpdate) {
                if (success) {
                    completedCalls++;
                    if (recovered) recoveredCalls++;
                } else {
                    failedCalls++;
                }

                onMetricsUpdate({
                    completedApiCalls: completedCalls,
                    failedApiCalls: failedCalls,
                    recoveredApiCalls: recoveredCalls,
                    totalRecordsReceived: accumulatedData.length,
                    apiCallsHistory: [{
                        type,
                        page,
                        duration,
                        success,
                        recovered
                    }]
                });
            }
        };

        // Modificar cargarRangoPaginas para reportar cada llamada
        const cargarRangoConReporte = async (apiUrl, filtros, startPage, endPage, pageSize, paginador, cacheId) => {
            // Si está en caché, reportar como llamada instantánea
            if (dataCache.hasRange(cacheId, apiUrl, filtros, startPage, endPage, pageSize)) {
                const cachedData = dataCache.getRange(cacheId, apiUrl, filtros, startPage, endPage, pageSize);
                if (cachedData && Array.isArray(cachedData) && cachedData.length > 0) {
                    reportApiCall('CACHE', `${startPage}-${endPage}`, 0, true);
                    return cachedData;
                }
            }

            const collectedData = [];

            for (let page = startPage; page <= endPage; page++) {
                const startTime = Date.now();
                try {
                    // Hacer la llamada API individual
                    const requestId = generateRequestId();
                    const response = await axios.post(apiUrl, {
                        ...filtros,
                        page: page,
                        limit: pageSize,
                        count: false
                    }, {
                        timeout: 60000,
                        maxContentLength: 50 * 1024 * 1024,
                        maxBodyLength: 50 * 1024 * 1024,
                    });

                    const duration = Date.now() - startTime;

                    let pageData = [];
                    if (response.data.pagination === undefined) {
                        pageData = response.data.data.items || [];
                    } else {
                        pageData = response.data.data || [];
                    }

                    collectedData.push(...pageData);
                    reportApiCall('API', page, duration, true);

                } catch (error) {
                    const duration = Date.now() - startTime;
                    reportApiCall('API', page, duration, false);

                    // Intentar recuperar
                    await new Promise(resolve => setTimeout(resolve, 1000));
                    try {
                        const response = await axios.post(apiUrl, {
                            ...filtros,
                            page: page,
                            limit: pageSize,
                            count: false
                        }, {
                            timeout: 60000,
                            maxContentLength: 50 * 1024 * 1024,
                            maxBodyLength: 50 * 1024 * 1024,
                        });

                        const recoveryDuration = Date.now() - startTime;

                        let pageData = [];
                        if (response.data.pagination === undefined) {
                            pageData = response.data.data.items || [];
                        } else {
                            pageData = response.data.data || [];
                        }

                        collectedData.push(...pageData);
                        reportApiCall('RECOVERY', page, recoveryDuration, true, true);

                    } catch (recoveryError) {
                        const recoveryDuration = Date.now() - startTime;
                        reportApiCall('RECOVERY', page, recoveryDuration, false);
                    }
                }
            }

            // Guardar en caché
            if (collectedData.length > 0) {
                dataCache.storeRange(cacheId, apiUrl, filtros, startPage, endPage, pageSize, collectedData);
            }

            return collectedData;
        };

        // Carga por bloques con reporte de progreso
        const PARALLEL_BLOCKS = totalRecordsFromAPI > 50000 ? 3 : 5;
        const BLOCK_SIZE = Math.ceil(pagesNeeded / 10);

        const blocks = [];
        for (let page = 1; page <= pagesNeeded; page += BLOCK_SIZE) {
            const blockEndPage = Math.min(page + BLOCK_SIZE - 1, pagesNeeded);
            blocks.push({ startPage: page, endPage: blockEndPage });
        }

        for (let i = 0; i < blocks.length; i += PARALLEL_BLOCKS) {
            const currentBlocks = blocks.slice(i, i + PARALLEL_BLOCKS);
            const currentBlocksPromises = currentBlocks.map(block =>
                cargarRangoConReporte(apiUrl, filtros, block.startPage, block.endPage, pageSize, paginador, cacheId)
            );
            const blocksResults = await Promise.all(currentBlocksPromises);

            for (const blockData of blocksResults) {
                if (blockData && Array.isArray(blockData)) {
                    accumulatedData = [...accumulatedData, ...blockData];
                }
            }

            paginador.editarDatos(accumulatedData);
            paginador.editarDatosCargados(accumulatedData.length);

            const lastProcessedBlock = currentBlocks[currentBlocks.length - 1];
            const pagesProcessed = lastProcessedBlock.endPage;
            const progress = Math.round((pagesProcessed / pagesNeeded) * 100);
            paginador.editarProgresoCargado(progress);

            // ✅ ACTUALIZAR PROGRESO EN TIEMPO REAL
            if (onMetricsUpdate) {
                onMetricsUpdate({
                    totalRecordsReceived: accumulatedData.length,
                    downloadProgress: progress
                });
            }

            // Callback para datos parciales
            if (typeof onPartialData === 'function') {
                onPartialData(accumulatedData, progress);
            }

            await new Promise(resolve => setTimeout(resolve, 100));
        }

        paginador.editarCargaCompletada(true);
        paginador.editarCargando(false);
        paginador.editarProgresoCargado(100);

        // ✅ MARCAR COMO COMPLETADO
        if (onMetricsUpdate) {
            onMetricsUpdate({
                searchEndTime: Date.now(),
                downloadProgress: 100
            });
        }

    } catch (error) {
        console.error("Error global en carga de datos:", error);
        paginador.editarError(`Error en carga de datos: ${error.message || error}`);
        paginador.editarCargando(false);

        if (typeof onPartialData === 'function') {
            onPartialData([], 0, error.message || "Error en carga de datos");
        }
    }
};




/*conexiones con optimizaciones*/

// ✅ POOL DE CONEXIONES REUTILIZABLE
const apiClient = axios.create({
    timeout: 60000,
    maxContentLength: 50 * 1024 * 1024,
    maxBodyLength: 50 * 1024 * 1024,
    // ✅ MANTENER CONEXIONES VIVAS
    keepAlive: true,
    maxRedirects: 3
});



// ✅ FUNCIÓN DE PETICIÓN OPTIMIZADA SIN LOGS EXCESIVOS
// ✅ FUNCIÓN DE PETICIÓN OPTIMIZADA CORREGIDA
const fetchPageOptimized = async (apiUrl, filtros, page, pageSize, isRetry = false) => {
    const requestId = generateRequestId();
    const startTime = performance.now();

    try {
        const response = await apiClient.post(apiUrl, {
            ...filtros,
            page,
            limit: pageSize,
            count: page === 1 // Solo contar en la primera página
        });

        const duration = performance.now() - startTime;

        // ✅ LOG MÍNIMO (solo si hay problemas)
        if (duration > 5000) {
            console.warn(`⚠️ Página ${page} tardó ${Math.round(duration)}ms`);
        }

        let pageData = [];
        let totalRecords = 0;
        let totalPages = 0;

        // ✅ EXTRAER DATOS SEGÚN LA ESTRUCTURA (IGUAL QUE ANTES)
        if (response.data.data?.pagination) {
            // Estructura de alertas de cámara/IA
            pageData = response.data.data.items || [];
            totalPages = response.data.data.pagination.lastPage || 0;
            totalRecords = response.data.data.pagination.total || 0;
        } else if (response.data.pagination) {
            // Estructura de alertas GPS
            pageData = response.data.data || [];
            totalPages = response.data.pagination.lastPage || 0;
            totalRecords = response.data.pagination.total || 0;
        } else {
            // Estructura alternativa o fallback
            pageData = response.data.data?.items || response.data.data || [];
            totalRecords = pageData.length;
            totalPages = 1;
        }

        return {
            success: true,
            data: pageData,
            duration: Math.round(duration),
            requestId,
            page,
            isRetry,
            // ✅ INCLUIR METADATOS PARA LA PRIMERA PÁGINA
            totalRecords: page === 1 ? totalRecords : undefined,
            totalPages: page === 1 ? totalPages : undefined,
            rawResponse: response // Para debug si es necesario
        };

    } catch (error) {
        const duration = performance.now() - startTime;

        return {
            success: false,
            error: error.message,
            duration: Math.round(duration),
            requestId,
            page,
            isRetry
        };
    }
};


// ✅ NUEVA FUNCIÓN CON PROGRESO GRANULAR
const cargarPaginasConMetricasOptimizado = async (apiUrl, paginador, filtros, cacheId = 'default', onPartialData = null, onMetricsUpdate = null) => {
    const searchStartTime = Date.now();

    try {
        // ✅ INICIALIZAR ESTADOS
        paginador.editarCargando(true);
        paginador.editarCargaCompletada(false);
        paginador.editarDatos([]);
        paginador.editarProgresoCargado(0);

        // ✅ OBTENER METADATOS MÁS RÁPIDO
        const { totalPages, totalRecordsFromAPI, error, errorMessage } = await obtenerMetadatos(apiUrl, filtros, paginador);

        if (error || totalRecordsFromAPI === 0) {
            paginador.editarCargaCompletada(true);
            paginador.editarCargando(false);
            if (onPartialData) onPartialData([], 100, error ? errorMessage : null);
            return;
        }

        const strategy = getLoadingStrategy(totalRecordsFromAPI);
        const pageSize = strategy.subsequentPageSize;
        const pagesNeeded = Math.ceil(totalRecordsFromAPI / pageSize);

        // ✅ INICIALIZAR CONTADORES DE PROGRESO
        let accumulatedData = [];
        let completedCalls = 0;
        let totalCallsPlanned = pagesNeeded;
        let processingStartTime = Date.now();

        // ✅ REPORTAR METADATOS INMEDIATAMENTE
        if (onMetricsUpdate) {
            onMetricsUpdate({
                totalRecordsExpected: totalRecordsFromAPI,
                totalApiCalls: totalCallsPlanned,
                searchStartTime,
                downloadProgress: 0
            });
        }

        // ✅ FUNCIÓN MEJORADA PARA REPORTAR CADA PETICIÓN INDIVIDUAL
        const reportApiCall = (type, page, duration, success, pageData = [], recovered = false) => {
            if (success) {
                completedCalls++;
                accumulatedData = [...accumulatedData, ...pageData];

                // ✅ ACTUALIZAR PAGINADOR INMEDIATAMENTE
                paginador.editarDatos(accumulatedData);
                paginador.editarDatosCargados(accumulatedData.length);

                // ✅ CALCULAR PROGRESO MÁS PRECISO
                const progressPercentage = Math.round((completedCalls / totalCallsPlanned) * 100);
                paginador.editarProgresoCargado(progressPercentage);

                // ✅ REPORTAR PROGRESO INMEDIATAMENTE
                if (onMetricsUpdate) {
                    onMetricsUpdate({
                        completedApiCalls: completedCalls,
                        totalRecordsReceived: accumulatedData.length,
                        downloadProgress: progressPercentage,
                        estimatedTimeRemaining: calculateETA(completedCalls, totalCallsPlanned, processingStartTime),
                        currentSpeed: calculateSpeed(accumulatedData.length, Date.now() - processingStartTime),
                        apiCallsHistory: [{
                            type,
                            page,
                            duration,
                            success,
                            recovered,
                            timestamp: Date.now(),
                            records: pageData.length,
                            totalRecordsNow: accumulatedData.length
                        }]
                    });
                }

                // ✅ ENVIAR DATOS PARCIALES MÁS FRECUENTEMENTE
                if (onPartialData && (completedCalls % 2 === 0 || completedCalls === totalCallsPlanned)) {
                    onPartialData(accumulatedData, progressPercentage);
                }
            }
        };

        // ✅ FUNCIÓN INDIVIDUAL DE PETICIÓN MEJORADA
        const fetchSinglePage = async (page, retryCount = 0) => {
            const requestId = generateRequestId();
            const startTime = Date.now();

            try {
                console.log(`🔄 [${requestId}] Petición página ${page} (${completedCalls + 1}/${totalCallsPlanned})`);

                const response = await apiClient.post(apiUrl, {
                    ...filtros,
                    page,
                    limit: pageSize,
                    count: false
                });

                const duration = Date.now() - startTime;

                let pageData = [];
                if (response.data.pagination === undefined) {
                    pageData = response.data.data.items || [];
                } else {
                    pageData = response.data.data || [];
                }

                console.log(`✅ [${requestId}] Página ${page} completada: ${pageData.length} registros en ${duration}ms`);

                // ✅ REPORTAR INMEDIATAMENTE CADA PETICIÓN EXITOSA
                reportApiCall('API', page, duration, true, pageData, retryCount > 0);

                return { success: true, data: pageData };

            } catch (error) {
                const duration = Date.now() - startTime;
                console.error(`❌ [${requestId}] Error página ${page}:`, error.message);

                // ✅ REINTENTO AUTOMÁTICO
                if (retryCount < 2) {
                    console.log(`🔁 [${requestId}] Reintentando página ${page} (intento ${retryCount + 1})`);
                    await new Promise(resolve => setTimeout(resolve, 1000 * (retryCount + 1)));
                    return fetchSinglePage(page, retryCount + 1);
                }

                // ✅ REPORTAR FALLO DESPUÉS DE REINTENTOS
                reportApiCall('API', page, duration, false, [], false);
                return { success: false, error: error.message };
            }
        };

        // ✅ CARGA CON PARALELISMO CONTROLADO PERO PROGRESO INDIVIDUAL
        const MAX_CONCURRENT = totalRecordsFromAPI > 100000 ? 8 : 12;
        const pagePromises = [];

        //console.log(`🚀 Iniciando carga de ${pagesNeeded} páginas con ${MAX_CONCURRENT} conexiones paralelas`);

        // ✅ CREAR TODAS LAS PROMESAS PERO CONTROLAR CONCURRENCIA
        for (let page = 1; page <= pagesNeeded; page++) {
            pagePromises.push(() => fetchSinglePage(page));
        }

        // ✅ EJECUTAR CON CONTROL DE CONCURRENCIA
        await executeWithConcurrencyControl(pagePromises, MAX_CONCURRENT);

        // ✅ FINALIZAR
        paginador.editarCargaCompletada(true);
        paginador.editarCargando(false);
        paginador.editarProgresoCargado(100);

        if (onMetricsUpdate) {
            onMetricsUpdate({
                searchEndTime: Date.now(),
                downloadProgress: 100,
                finalRecordsCount: accumulatedData.length
            });
        }

        //console.log(`✅ Carga completada: ${accumulatedData.length} registros en ${Date.now() - searchStartTime}ms`);

    } catch (error) {
        console.error("❌ Error en carga optimizada:", error);
        paginador.editarError(`Error: ${error.message}`);
        paginador.editarCargando(false);

        if (onPartialData) {
            onPartialData([], 0, error.message);
        }
    }
};

// ✅ CONTROL DE CONCURRENCIA INTELIGENTE
const executeWithConcurrencyControl = async (promiseFunctions, maxConcurrent) => {
    const results = [];
    const executing = [];

    for (const promiseFunction of promiseFunctions) {
        const promise = promiseFunction().then(result => {
            // Remover de la lista de ejecutándose cuando termine
            executing.splice(executing.indexOf(promise), 1);
            return result;
        });

        results.push(promise);
        executing.push(promise);

        // ✅ ESPERAR SI ALCANZAMOS EL LÍMITE DE CONCURRENCIA
        if (executing.length >= maxConcurrent) {
            await Promise.race(executing);
        }
    }

    // ✅ ESPERAR QUE TERMINEN TODAS
    return Promise.all(results);
};

// ✅ FUNCIONES AUXILIARES PARA MÉTRICAS EN TIEMPO REAL
const calculateETA = (completed, total, startTime) => {
    if (completed === 0) return "Calculando...";

    const elapsed = Date.now() - startTime;
    const avgTimePerCall = elapsed / completed;
    const remaining = total - completed;
    const etaMs = remaining * avgTimePerCall;

    return formatTime(etaMs);
};

const calculateSpeed = (records, timeMs) => {
    if (timeMs === 0) return "0 registros/s";

    const recordsPerSecond = Math.round((records / timeMs) * 1000);
    return `${recordsPerSecond.toLocaleString()} registros/s`;
};

const formatTime = (ms) => {
    if (ms < 1000) return `${Math.round(ms)}ms`;
    if (ms < 60000) return `${Math.round(ms / 1000)}s`;
    return `${Math.round(ms / 60000)}m ${Math.round((ms % 60000) / 1000)}s`;
};


// ✅ FUNCIÓN PRINCIPAL CORREGIDA - USAR LA LÓGICA ORIGINAL
const cargarPaginasConMetricasOptimizado_Back31052025 = async (apiUrl, paginador, filtros, cacheId = 'default', onPartialData = null, onMetricsUpdate = null) => {
    const searchStartTime = Date.now();

    try {
        // ✅ INICIALIZAR ESTADOS
        paginador.editarCargando(true);
        paginador.editarCargaCompletada(false);
        paginador.editarDatos([]);
        paginador.editarProgresoCargado(0);

        // ✅ OBTENER METADATOS USANDO LA FUNCIÓN ORIGINAL QUE FUNCIONA
        const { totalPages, totalRecordsFromAPI, error, errorMessage } = await obtenerMetadatos(apiUrl, filtros, paginador);

        // ✅ CALCULAR estimatedCalls AQUÍ PARA QUE ESTÉ DISPONIBLE
        const strategy = getLoadingStrategy(totalRecordsFromAPI);
        const pageSize = strategy.subsequentPageSize;
        const estimatedCalls = Math.ceil(totalRecordsFromAPI / pageSize);

        // ✅ REPORTAR METADATOS INMEDIATAMENTE
        if (onMetricsUpdate) {
            onMetricsUpdate({
                totalRecordsExpected: totalRecordsFromAPI,
                totalApiCalls: estimatedCalls,
                searchStartTime
            });
        }

        if (error) {
            if (typeof onPartialData === 'function') {
                onPartialData([], 0, errorMessage);
            }
            return;
        }

        if (totalRecordsFromAPI === 0) {
            paginador.editarCargaCompletada(true);
            paginador.editarCargando(false);
            if (onPartialData) onPartialData([], 100);
            return;
        }

        // ✅ USAR LA LÓGICA ORIGINAL DE CARGA QUE YA FUNCIONABA
        const pagesNeeded = Math.ceil(totalRecordsFromAPI / pageSize);

        let accumulatedData = [];
        let completedCalls = 0;
        let failedCalls = 0;
        let recoveredCalls = 0;

        // ✅ FUNCIÓN PARA REPORTAR LLAMADA API - AHORA CON estimatedCalls DISPONIBLE
        const reportApiCall = (type, page, duration, success, recovered = false, records = 0) => {
            if (onMetricsUpdate) {
                if (success) {
                    completedCalls++;
                    if (recovered) recoveredCalls++;
                } else {
                    failedCalls++;
                }

                onMetricsUpdate({
                    completedApiCalls: completedCalls,
                    failedApiCalls: failedCalls,
                    recoveredApiCalls: recoveredCalls,
                    totalRecordsReceived: accumulatedData.length,
                    downloadProgress: Math.round((completedCalls / estimatedCalls) * 100), // ✅ AHORA ESTÁ DEFINIDO
                    apiCallsHistory: [{
                        type,
                        page,
                        duration,
                        success,
                        recovered,
                        timestamp: Date.now(),
                        records
                    }]
                });
            }
        };

        // ✅ USAR cargarRangoPaginas ORIGINAL con reporte
        const cargarRangoConReporte = async (apiUrl, filtros, startPage, endPage, pageSize, paginador, cacheId) => {
            // Verificar caché
            if (dataCache.hasRange(cacheId, apiUrl, filtros, startPage, endPage, pageSize)) {
                const cachedData = dataCache.getRange(cacheId, apiUrl, filtros, startPage, endPage, pageSize);
                if (cachedData && Array.isArray(cachedData) && cachedData.length > 0) {
                    reportApiCall('CACHE', `${startPage}-${endPage}`, 0, true, false, cachedData.length);
                    return cachedData;
                }
            }

            //console.log(`Cargando páginas ${startPage}-${endPage} con tamaño ${pageSize}`);
            const collectedData = [];

            // Configuración para reintentos
            const maxRetries = 2;
            const retryDelay = 1000;

            // Función con reintentos
            const fetchPageWithRetry = async (page, retryCount = 0) => {
                const requestId = generateRequestId();

                try {
                    const startTime = performance.now();
                    const response = await axios.post(apiUrl, {
                        ...filtros,
                        page: page,
                        limit: pageSize,
                        count: false
                    }, {
                        timeout: 60000,
                        maxContentLength: 50 * 1024 * 1024,
                        maxBodyLength: 50 * 1024 * 1024,
                    });
                    const endTime = performance.now();
                    const duration = Math.round(endTime - startTime);

                    let pageData = [];
                    if (response.data.pagination === undefined) {
                        pageData = response.data.data.items || [];
                    } else {
                        pageData = response.data.data || [];
                    }

                    reportApiCall('API', page, duration, true, retryCount > 0, pageData.length);
                    return { success: true, page, data: pageData };

                } catch (error) {
                    const duration = 5000; // Estimado para errores
                    reportApiCall('API', page, duration, false, false, 0);

                    // Reintento
                    if (retryCount < maxRetries) {
                        await new Promise(resolve => setTimeout(resolve, retryDelay));
                        return fetchPageWithRetry(page, retryCount + 1);
                    }

                    paginador.editarPaginasNoCargadas({
                        id: requestId,
                        pagina: page,
                        error: `Error en página ${page}: ${error.message || error}`
                    });

                    return { success: false, page, error };
                }
            };

            // Procesar páginas en lotes de 5
            const BATCH_SIZE = 5;

            for (let batchStart = startPage; batchStart <= endPage; batchStart += BATCH_SIZE) {
                const batchEnd = Math.min(batchStart + BATCH_SIZE - 1, endPage);
                const batchPromises = [];

                for (let page = batchStart; page <= batchEnd; page++) {
                    batchPromises.push(fetchPageWithRetry(page));
                }

                const results = await Promise.all(batchPromises);

                results.forEach(result => {
                    if (result.success) {
                        collectedData.push(...result.data);
                    }
                });

                if (batchEnd < endPage) {
                    await new Promise(resolve => setTimeout(resolve, 50));
                }
            }

            // Guardar en caché
            if (collectedData.length > 0) {
                dataCache.storeRange(cacheId, apiUrl, filtros, startPage, endPage, pageSize, collectedData);
            }

            return collectedData;
        };

        // ✅ CARGA POR BLOQUES CON REPORTE DE PROGRESO (LÓGICA ORIGINAL)
        const PARALLEL_BLOCKS = totalRecordsFromAPI > 50000 ? 3 : 5;
        const BLOCK_SIZE = Math.ceil(pagesNeeded / 10);

        const blocks = [];
        for (let page = 1; page <= pagesNeeded; page += BLOCK_SIZE) {
            const blockEndPage = Math.min(page + BLOCK_SIZE - 1, pagesNeeded);
            blocks.push({ startPage: page, endPage: blockEndPage });
        }

        for (let i = 0; i < blocks.length; i += PARALLEL_BLOCKS) {
            const currentBlocks = blocks.slice(i, i + PARALLEL_BLOCKS);
            const currentBlocksPromises = currentBlocks.map(block =>
                cargarRangoConReporte(apiUrl, filtros, block.startPage, block.endPage, pageSize, paginador, cacheId)
            );
            const blocksResults = await Promise.all(currentBlocksPromises);

            for (const blockData of blocksResults) {
                if (blockData && Array.isArray(blockData)) {
                    accumulatedData = [...accumulatedData, ...blockData];
                }
            }

            paginador.editarDatos(accumulatedData);
            paginador.editarDatosCargados(accumulatedData.length);

            const lastProcessedBlock = currentBlocks[currentBlocks.length - 1];
            const pagesProcessed = lastProcessedBlock.endPage;
            const progress = Math.round((pagesProcessed / pagesNeeded) * 100);
            paginador.editarProgresoCargado(progress);

            // ✅ ACTUALIZAR PROGRESO EN TIEMPO REAL
            if (onMetricsUpdate) {
                onMetricsUpdate({
                    totalRecordsReceived: accumulatedData.length,
                    downloadProgress: progress
                });
            }

            // Callback para datos parciales
            if (typeof onPartialData === 'function') {
                onPartialData(accumulatedData, progress);
            }

            await new Promise(resolve => setTimeout(resolve, 100));
        }

        // ✅ FINALIZAR
        paginador.editarCargaCompletada(true);
        paginador.editarCargando(false);
        paginador.editarProgresoCargado(100);

        if (onMetricsUpdate) {
            onMetricsUpdate({
                searchEndTime: Date.now(),
                downloadProgress: 100
            });
        }

    } catch (error) {
        console.error("❌ Error en carga optimizada:", error);
        paginador.editarError(`Error: ${error.message}`);
        paginador.editarCargando(false);

        if (onPartialData) {
            onPartialData([], 0, error.message);
        }
    }
};


// ✅ FUNCIÓN ULTRA-OPTIMIZADA PARA STREAMING
export const cargarPaginasUltraOptimizado_respaldo31052025_1 = async (apiUrl, paginador, filtros, cacheId = 'default', onPartialData = null, onMetricsUpdate = null) => {
    const searchStartTime = Date.now();

    try {
        // ✅ INICIALIZAR ESTADOS CON STREAMING
        paginador.editarCargando(true);
        paginador.editarCargaCompletada(false);
        paginador.editarDatos([]);
        paginador.editarProgresoCargado(0);

        // ✅ OBTENER METADATOS MÁS RÁPIDO
        const { totalPages, totalRecordsFromAPI, error, errorMessage } = await obtenerMetadatos(apiUrl, filtros, paginador);

        if (error || totalRecordsFromAPI === 0) {
            paginador.editarCargaCompletada(true);
            paginador.editarCargando(false);
            if (onPartialData) onPartialData([], 100, error ? errorMessage : null);
            return;
        }

        const strategy = getLoadingStrategy(totalRecordsFromAPI);
        const pageSize = strategy.subsequentPageSize;
        const pagesNeeded = Math.ceil(totalRecordsFromAPI / pageSize);

        // ✅ STREAMING DE DATOS - ENVIAR DATOS PARCIALES CADA 5 REGISTROS
        let accumulatedData = [];
        let completedCalls = 0;
        let totalCallsPlanned = pagesNeeded;
        let processingStartTime = Date.now();
        let lastPartialUpdate = Date.now();

        // ✅ REPORTAR METADATOS INMEDIATAMENTE
        if (onMetricsUpdate) {
            onMetricsUpdate({
                totalRecordsExpected: totalRecordsFromAPI,
                totalApiCalls: totalCallsPlanned,
                searchStartTime,
                downloadProgress: 0
            });
        }

        // ✅ FUNCIÓN MEJORADA PARA STREAMING EN TIEMPO REAL
        const reportApiCallWithStreaming = (type, page, duration, success, pageData = [], recovered = false) => {
            if (success) {
                completedCalls++;
                accumulatedData = [...accumulatedData, ...pageData];

                // ✅ ACTUALIZAR PAGINADOR INMEDIATAMENTE
                paginador.editarDatos(accumulatedData);
                paginador.editarDatosCargados(accumulatedData.length);

                // ✅ CALCULAR PROGRESO MÁS PRECISO
                const progressPercentage = Math.round((completedCalls / totalCallsPlanned) * 100);
                paginador.editarProgresoCargado(progressPercentage);

                // ✅ REPORTAR PROGRESO INMEDIATAMENTE
                if (onMetricsUpdate) {
                    onMetricsUpdate({
                        completedApiCalls: completedCalls,
                        totalRecordsReceived: accumulatedData.length,
                        downloadProgress: progressPercentage,
                        estimatedTimeRemaining: calculateETA(completedCalls, totalCallsPlanned, processingStartTime),
                        currentSpeed: calculateSpeed(accumulatedData.length, Date.now() - processingStartTime),
                        apiCallsHistory: [{
                            type,
                            page,
                            duration,
                            success,
                            recovered,
                            timestamp: Date.now(),
                            records: pageData.length,
                            totalRecordsNow: accumulatedData.length
                        }]
                    });
                }

                // ✅ STREAMING: ENVIAR DATOS PARCIALES MÁS FRECUENTEMENTE
                const now = Date.now();
                if (onPartialData && (
                    completedCalls % 2 === 0 || // Cada 2 páginas
                    completedCalls === totalCallsPlanned || // Al final
                    (now - lastPartialUpdate) > 1000 // Cada segundo
                )) {
                    onPartialData(accumulatedData, progressPercentage);
                    lastPartialUpdate = now;
                }
            }
        };

        // ✅ USAR LA FUNCIÓN EXISTENTE PERO CON STREAMING
        const fetchSinglePageWithStreaming = async (page, retryCount = 0) => {
            const requestId = generateRequestId();
            const startTime = Date.now();

            try {
                console.log(`🔄 [${requestId}] Petición página ${page} (${completedCalls + 1}/${totalCallsPlanned})`);

                const response = await apiClient.post(apiUrl, {
                    ...filtros,
                    page,
                    limit: pageSize,
                    count: false
                });

                const duration = Date.now() - startTime;

                let pageData = [];
                if (response.data.pagination === undefined) {
                    pageData = response.data.data.items || [];
                } else {
                    pageData = response.data.data || [];
                }

                console.log(`✅ [${requestId}] Página ${page} completada: ${pageData.length} registros en ${duration}ms`);

                // ✅ REPORTAR INMEDIATAMENTE CON STREAMING
                reportApiCallWithStreaming('API', page, duration, true, pageData, retryCount > 0);

                return { success: true, data: pageData };

            } catch (error) {
                const duration = Date.now() - startTime;
                console.error(`❌ [${requestId}] Error página ${page}:`, error.message);

                // ✅ REINTENTO AUTOMÁTICO
                if (retryCount < 2) {
                    console.log(`🔁 [${requestId}] Reintentando página ${page} (intento ${retryCount + 1})`);
                    await new Promise(resolve => setTimeout(resolve, 1000 * (retryCount + 1)));
                    return fetchSinglePageWithStreaming(page, retryCount + 1);
                }

                // ✅ REPORTAR FALLO DESPUÉS DE REINTENTOS
                reportApiCallWithStreaming('API', page, duration, false, [], false);
                return { success: false, error: error.message };
            }
        };

        // ✅ USAR EL CONTROL DE CONCURRENCIA EXISTENTE
        const MAX_CONCURRENT = totalRecordsFromAPI > 100000 ? 8 : 12;
        const pagePromises = [];

        //console.log(`🚀 Iniciando carga STREAMING de ${pagesNeeded} páginas con ${MAX_CONCURRENT} conexiones paralelas`);

        // ✅ CREAR TODAS LAS PROMESAS PERO CONTROLAR CONCURRENCIA
        for (let page = 1; page <= pagesNeeded; page++) {
            pagePromises.push(() => fetchSinglePageWithStreaming(page));
        }

        // ✅ EJECUTAR CON CONTROL DE CONCURRENCIA
        await executeWithConcurrencyControl(pagePromises, MAX_CONCURRENT);

        // ✅ FINALIZAR
        paginador.editarCargaCompletada(true);
        paginador.editarCargando(false);
        paginador.editarProgresoCargado(100);

        // ✅ ENVÍO FINAL DE DATOS COMPLETOS
        if (onPartialData) {
            onPartialData(accumulatedData, 100);
        }

        if (onMetricsUpdate) {
            onMetricsUpdate({
                searchEndTime: Date.now(),
                downloadProgress: 100,
                finalRecordsCount: accumulatedData.length
            });
        }

        //console.log(`✅ Carga STREAMING completada: ${accumulatedData.length} registros en ${Date.now() - searchStartTime}ms`);

    } catch (error) {
        console.error("❌ Error en carga ultra-optimizada:", error);
        paginador.editarError(`Error: ${error.message}`);
        paginador.editarCargando(false);

        if (onPartialData) {
            onPartialData([], 0, error.message);
        }
    }
};

export const cargarPaginasUltraOptimizado = async (apiUrl, paginador, filtros, connectionId = 'Unknown', onPartialData = null, onMetricsUpdate = null) => {
    const searchStartTime = Date.now();

    // ✅ DECLARAR VARIABLES EN EL SCOPE CORRECTO CON IDENTIFICADOR DE CONEXIÓN
    let accumulatedData = [];
    let completedCalls = 0;
    let failedCalls = 0;
    let totalCallsPlanned = 0;
    let totalApiCallsMade = 0; // ✅ NUEVO: Contar TODAS las llamadas incluyendo reintentos
    let processingStartTime = Date.now();
    let lastPartialUpdate = Date.now();
    let recoveredCalls = 0; // ✅ NUEVO: Contar recuperaciones

    // ✅ IDENTIFICADOR ÚNICO PARA ESTA CONEXIÓN
    const connectionPrefix = `[${connectionId}]`;

    try {
        // ✅ INICIALIZAR ESTADOS
        paginador.editarCargando(true);
        paginador.editarCargaCompletada(false);
        paginador.editarDatos([]);
        paginador.editarProgresoCargado(0);

        // ✅ OBTENER METADATOS
        const { totalPages, totalRecordsFromAPI, error, errorMessage } = await obtenerMetadatos(apiUrl, filtros, paginador);

        if (error || totalRecordsFromAPI === 0) {
            paginador.editarCargaCompletada(true);
            paginador.editarCargando(false);
            if (onPartialData) onPartialData([], 100, error ? errorMessage : null);
            return;
        }

        const strategy = getLoadingStrategy(totalRecordsFromAPI);
        const pageSize = strategy.subsequentPageSize;
        const pagesNeeded = Math.ceil(totalRecordsFromAPI / pageSize);

        // ✅ INICIALIZAR VARIABLES AQUÍ
        totalCallsPlanned = pagesNeeded;
        processingStartTime = Date.now();

        //console.log(`🎯 ${connectionPrefix} OBJETIVO: ${totalRecordsFromAPI} registros en ${pagesNeeded} páginas`);

        // ✅ REPORTAR METADATOS INMEDIATAMENTE
        if (onMetricsUpdate) {
            onMetricsUpdate({
                connectionId, // ✅ INCLUIR IDENTIFICADOR DE CONEXIÓN
                totalRecordsExpected: totalRecordsFromAPI,
                totalApiCalls: totalCallsPlanned,
                searchStartTime,
                downloadProgress: 0
            });
        }

        // ✅ FUNCIÓN MEJORADA CON REPORTE DE REINTENTOS
        const reportApiCallWithRetries = (type, page, duration, success, pageData = [], recovered = false, attemptNumber = 1) => {
            // ✅ CONTAR CADA LLAMADA API (INCLUYENDO REINTENTOS)
            totalApiCallsMade++;

            if (success) {
                if (attemptNumber > 1) {
                    recoveredCalls++;
                    //console.log(`%c🔁✅ ${connectionPrefix} Página ${page} recuperada en intento ${attemptNumber}`, 'color: #00ff00; font-weight: bold; background: #004400; padding: 2px 6px; border-radius: 3px;');
                }

                completedCalls++;

                // ✅ VALIDAR DATOS ANTES DE ACUMULAR
                if (Array.isArray(pageData) && pageData.length > 0) {
                    accumulatedData = [...accumulatedData, ...pageData];
                    //console.log(`📊 ${connectionPrefix} Página ${page}: +${pageData.length} registros (Total: ${accumulatedData.length}/${totalRecordsFromAPI}) [Intento ${attemptNumber}]`);
                } else {
                    console.warn(`⚠️ ${connectionPrefix} Página ${page}: Sin datos válidos [Intento ${attemptNumber}]`);
                }

                const progressPercentage = Math.round((completedCalls / totalCallsPlanned) * 100);

                // ✅ REPORTAR PROGRESO CON MÉTRICAS DETALLADAS
                if (onMetricsUpdate) {
                    onMetricsUpdate({
                        connectionId, // ✅ INCLUIR IDENTIFICADOR DE CONEXIÓN
                        completedApiCalls: completedCalls,
                        failedApiCalls: failedCalls,
                        recoveredApiCalls: recoveredCalls,
                        totalApiCallsMade: totalApiCallsMade, // ✅ NUEVO: Total real de llamadas
                        totalRecordsReceived: accumulatedData.length,
                        downloadProgress: progressPercentage,
                        estimatedTimeRemaining: calculateETA(completedCalls, totalCallsPlanned, processingStartTime),
                        currentSpeed: calculateSpeed(accumulatedData.length, Date.now() - processingStartTime),
                        apiCallsHistory: [{
                            type,
                            page,
                            duration,
                            success,
                            recovered,
                            attemptNumber,
                            timestamp: Date.now(),
                            records: pageData.length
                        }]
                    });
                }

                // ✅ STREAMING CONTROLADO
                const now = Date.now();
                if (onPartialData && (
                    completedCalls % 3 === 0 || // Cada 3 páginas
                    completedCalls === totalCallsPlanned || // Al final
                    (now - lastPartialUpdate) > 2000 // Cada 2 segundos
                )) {
                    if (completedCalls < totalCallsPlanned) {
                        //console.log(`📤 ${connectionPrefix} Enviando progreso: ${accumulatedData.length} registros (${progressPercentage}%)`);
                    }
                    lastPartialUpdate = now;
                }
            } else {
                if (attemptNumber === 1) {
                    // Solo contar como fallo definitivo si es el primer intento que falla completamente
                    failedCalls++;
                }
                console.error(`❌ ${connectionPrefix} Página ${page} falló en intento ${attemptNumber} (${failedCalls} fallos totales)`);

                // ✅ REPORTAR FALLO TEMPORAL
                if (onMetricsUpdate) {
                    onMetricsUpdate({
                        connectionId, // ✅ INCLUIR IDENTIFICADOR DE CONEXIÓN
                        completedApiCalls: completedCalls,
                        failedApiCalls: failedCalls,
                        totalApiCallsMade: totalApiCallsMade,
                        apiCallsHistory: [{
                            type,
                            page,
                            duration,
                            success: false,
                            attemptNumber,
                            timestamp: Date.now()
                        }]
                    });
                }
            }
        };

        // ✅ FUNCIÓN DE PETICIÓN CON REINTENTOS AGRESIVOS
        const fetchSinglePageWithAggressiveRetries = async (page, retryCount = 0) => {
            const requestId = generateRequestId();
            const startTime = Date.now();
            const maxRetries = 5; // ✅ INCREMENTADO A 5 REINTENTOS
            const attemptNumber = retryCount + 1;

            try {
                //console.log(`🔄 ${connectionPrefix} [${requestId}] Página ${page}/${pagesNeeded} (intento ${attemptNumber}/${maxRetries + 1})`);

                // ✅ TIMEOUT PROGRESIVO: Más tiempo en cada reintento
                const baseTimeout = pageSize > 5000 ? 120000 : 60000;
                const timeoutMs = baseTimeout + (retryCount * 30000); // +30s por cada reintento

                const response = await apiClient.post(apiUrl, {
                    ...filtros,
                    page,
                    limit: pageSize,
                    count: false
                }, {
                    timeout: timeoutMs
                });

                const duration = Date.now() - startTime;

                let pageData = [];
                if (response.data?.pagination === undefined) {
                    pageData = response.data?.data?.items || [];
                } else {
                    pageData = response.data?.data || [];
                }

                // ✅ VALIDACIÓN DE DATOS RECIBIDOS MEJORADA
                if (!Array.isArray(pageData)) {
                    console.warn(`⚠️ ${connectionPrefix} [${requestId}] Página ${page}: Datos no válidos [Intento ${attemptNumber}]`);
                    pageData = [];
                }

                // ✅ DETECTAR PÁGINAS VACÍAS SOSPECHOSAS (excepto la última página)
                const isLastPage = page === pagesNeeded;
                const isEmpty = pageData.length === 0;
                const isSuspiciousEmpty = isEmpty && !isLastPage && retryCount < 3; // ✅ AUMENTADO A 3 REINTENTOS

                // ✅ DIAGNÓSTICO DETALLADO DE PÁGINAS VACÍAS
                if (isEmpty) {
                    //console.log(`🔍 ${connectionPrefix} [${requestId}] Página ${page} VACÍA - Diagnóstico:`);
                    //console.log(`   • isLastPage: ${isLastPage} (página ${page} de ${pagesNeeded})`);
                    //console.log(`   • retryCount: ${retryCount}`);
                    //console.log(`   • isSuspiciousEmpty: ${isSuspiciousEmpty}`);
                }

                if (isSuspiciousEmpty) {
                    console.warn(`🔍 ${connectionPrefix} [${requestId}] Página ${page}: Vacía sospechosa (no es última página), reintentando... (${retryCount + 1}/3)`);
                    
                    // ✅ PEQUEÑA PAUSA ANTES DE REINTENTAR PÁGINA VACÍA
                    await new Promise(resolve => setTimeout(resolve, 1000));
                    return fetchSinglePageWithAggressiveRetries(page, retryCount + 1);
                }

                const isRecovered = retryCount > 0;
                /*const statusMessage = isEmpty ? 
                    (isLastPage ? '(VACÍA - ÚLTIMA PÁGINA)' : '(VACÍA - ACEPTADA TRAS REINTENTOS)') : 
                    '';*/
                
                if (isRecovered) {
                    //console.log(`%c✅ ${connectionPrefix} [${requestId}] Página ${page}: ${pageData.length} registros en ${duration}ms [Intento ${attemptNumber}] 🔁 RECUPERADA ${statusMessage}`, 'color: #00ff00; font-weight: bold; background: #004400; padding: 2px 6px; border-radius: 3px;');
                } else {
                    //console.log(`✅ ${connectionPrefix} [${requestId}] Página ${page}: ${pageData.length} registros en ${duration}ms [Intento ${attemptNumber}] ${statusMessage}`);
                }

                reportApiCallWithRetries('API', page, duration, true, pageData, isRecovered, attemptNumber);

                return { success: true, data: pageData, page, duration, attemptNumber };

            } catch (error) {
                const duration = Date.now() - startTime;
                console.error(`❌ ${connectionPrefix} [${requestId}] Error página ${page} [Intento ${attemptNumber}]:`, error.message);

                // ✅ REPORTAR CADA INTENTO FALLIDO
                reportApiCallWithRetries('API', page, duration, false, [], false, attemptNumber);

                // ✅ REINTENTOS MÁS AGRESIVOS
                if (retryCount < maxRetries) {
                    // ✅ BACKOFF EXPONENCIAL PERO CON LÍMITE
                    const delay = Math.min(1000 * Math.pow(1.5, retryCount), 15000); // Max 15 segundos
                    //console.log(`🔁 ${connectionPrefix} [${requestId}] Reintentando página ${page} en ${delay}ms... (${retryCount + 1}/${maxRetries})`);

                    await new Promise(resolve => setTimeout(resolve, delay));
                    return fetchSinglePageWithAggressiveRetries(page, retryCount + 1);
                }

                console.error(`💀 ${connectionPrefix} [${requestId}] Página ${page} falló definitivamente después de ${maxRetries + 1} intentos`);

                return { success: false, error: error.message, page, attemptNumber };
            }
        };

        // ✅ CONTROL DE CONCURRENCIA CONSERVADOR PERO EFICIENTE
        const MAX_CONCURRENT = totalRecordsFromAPI > 200000 ? 4 : 6; // ✅ REDUCIDO para dar más tiempo a reintentos
        const pagePromises = [];

        // ✅ DIAGNÓSTICO ADICIONAL PARA CONEXIONES SIMULTÁNEAS
        //console.log(`🔍 ${connectionPrefix} DIAGNÓSTICO INICIAL:`, {
        //    totalRegistrosEsperados: totalRecordsFromAPI,
        //    paginasNecesarias: pagesNeeded,
        //    tamañoPagina: pageSize,
        //    concurrenciaMaxima: MAX_CONCURRENT,
        //    endpointAPI: apiUrl,
        //    timestamp: new Date().toISOString()
        //});

        // ✅ VERIFICAR CÁLCULO DE PÁGINAS
        const expectedPages = Math.ceil(totalRecordsFromAPI / pageSize);
        if (expectedPages !== pagesNeeded) {
            console.warn(`⚠️ ${connectionPrefix} INCONSISTENCIA EN CÁLCULO DE PÁGINAS:`, {
                paginasCalculadas: pagesNeeded,
                paginasEsperadas: expectedPages,
                diferencia: Math.abs(expectedPages - pagesNeeded)
            });
        }

        //console.log(`🚀 ${connectionPrefix} Iniciando descarga: ${pagesNeeded} páginas con ${MAX_CONCURRENT} conexiones paralelas y hasta 5 reintentos por página`);

        for (let page = 1; page <= pagesNeeded; page++) {
            pagePromises.push(() => fetchSinglePageWithAggressiveRetries(page));
        }

        // ✅ EJECUTAR CON CONTROL ESTRICTO
        //console.log(`⏰ ${connectionPrefix} Iniciando ejecución de ${pagePromises.length} promesas con control de concurrencia...`);
        const results = await executeWithConcurrencyControl(pagePromises, MAX_CONCURRENT);
        //console.log(`✅ ${connectionPrefix} Finalizada ejecución de promesas, procesando resultados...`);

        // ✅ ANÁLISIS FINAL DETALLADO CON DIAGNÓSTICO MEJORADO
        const successfulResults = results.filter(r => r && r.success);
        const failedResults = results.filter(r => r && !r.success);
        const recoveredResults = successfulResults.filter(r => r.attemptNumber > 1);

        // ✅ DIAGNÓSTICO INMEDIATO DE PÁGINAS VACÍAS
        const emptyPages = successfulResults.filter(r => r.data && r.data.length === 0);
        const emptyIntermediatePages = emptyPages.filter(r => r.page < pagesNeeded);
        
        if (emptyPages.length > 0) {
            console.warn(`📋 ${connectionPrefix} PÁGINAS VACÍAS DETECTADAS:`, {
                totalPaginasVacías: emptyPages.length,
                paginasVacías: emptyPages.map(r => r.page),
                paginasIntermediasVacías: emptyIntermediatePages.length,
                esProblematico: emptyIntermediatePages.length > 0
            });
            
            if (emptyIntermediatePages.length > 0) {
                console.error(`🚨 ${connectionPrefix} ALERTA: Páginas intermedias vacías detectadas en ${emptyIntermediatePages.map(r => r.page).join(', ')}`);
            }
        }

        // ✅ DIAGNÓSTICO DE PÁGINAS FALLIDAS
        if (failedResults.length > 0) {
            //console.warn(`🔍 ${connectionPrefix} ANÁLISIS DE PÁGINAS FALLIDAS:`, {
            //    paginasFallidas: failedResults.map(r => ({
            //        pagina: r.page,
            //        error: r.error,
            //        intentos: r.attemptNumber || 'desconocido'
            //    })),
            //    totalFallos: failedResults.length,
            //    porcentajeFallos: ((failedResults.length / pagesNeeded) * 100).toFixed(2) + '%'
            //});
        }

        const completenessPercentage = (accumulatedData.length / totalRecordsFromAPI) * 100;
        const isComplete = completenessPercentage >= 95; // ✅ REDUCIDO A 95% para ser más flexible

        // ✅ DIAGNÓSTICO ESPECIAL PARA CARGAS SIMULTÁNEAS
        if (!isComplete && failedResults.length > 0) {
            //console.warn(`🔍 ${connectionPrefix} POSIBLE PROBLEMA DE CARGAS SIMULTÁNEAS DETECTADO:`, {
            //    registrosObtenidos: accumulatedData.length,
            //    registrosEsperados: totalRecordsFromAPI,
            //    déficit: totalRecordsFromAPI - accumulatedData.length,
            //    paginasExitosas: successfulResults.length,
            //    paginasFallidas: failedResults.length,
            //    llamadasAPITotales: totalApiCallsMade,
            //    llamadasPlanificadas: totalCallsPlanned,
            //    tipoProblema: totalApiCallsMade < totalCallsPlanned ? 'POCAS_LLAMADAS_API' : 'FALLOS_EN_RESPUESTAS'
            //});

            // ✅ VERIFICAR SI EL PROBLEMA ES TIMEOUT O CONCURRENCIA
            const timeoutErrors = failedResults.filter(r => r.error && r.error.includes('timeout'));
            const connectionErrors = failedResults.filter(r => r.error && (r.error.includes('ECONNRESET') || r.error.includes('ETIMEDOUT')));
            
            if (timeoutErrors.length > 0) {
                console.warn(`⏰ ${connectionPrefix} TIMEOUTS DETECTADOS: ${timeoutErrors.length} páginas fallaron por timeout`);
            }
            if (connectionErrors.length > 0) {
                console.warn(`🔌 ${connectionPrefix} PROBLEMAS DE CONEXIÓN: ${connectionErrors.length} páginas fallaron por problemas de red`);
            }
        }

        // ✅ DIAGNÓSTICO ADICIONAL PARA PÁGINAS VACÍAS Y REGISTROS FALTANTES
        if (!isComplete) {
            const emptyPageResults = successfulResults.filter(r => r.data && r.data.length === 0);
            const emptyIntermediatePages = emptyPageResults.filter(r => r.page < pagesNeeded); // Páginas vacías que NO son la última
            const déficitRegistros = totalRecordsFromAPI - accumulatedData.length;
            
            //console.warn(`🔍 ${connectionPrefix} ANÁLISIS DE REGISTROS FALTANTES:`, {
            //    paginasVacías: emptyPageResults.length,
            //    paginasVacíasIntermedias: emptyIntermediatePages.length, // ✅ NUEVO
            //    paginasVacíasDetalle: emptyPageResults.map(r => `Página ${r.page}`),
            //    paginasVacíasIntermediasDetalle: emptyIntermediatePages.map(r => `Página ${r.page}`), // ✅ NUEVO
            //    déficitRegistros,
            //    porcentajeCompletitud: completenessPercentage.toFixed(2) + '%',
            //    posibleCausa: emptyIntermediatePages.length > 0 ? 
            //        'PÁGINAS_INTERMEDIAS_VACÍAS_SOSPECHOSAS' : 
            //        (emptyPageResults.length > 0 ? 'PÁGINAS_VACÍAS_INESPERADAS' : 'PÁGINAS_FALTANTES')
            //});

            // ✅ ADVERTENCIA ESPECÍFICA PARA PÁGINAS INTERMEDIAS VACÍAS
            if (emptyIntermediatePages.length > 0) {
                console.error(`🚨 ${connectionPrefix} PROBLEMA CRÍTICO: Páginas intermedias vacías detectadas!`);
                console.error(`   Páginas problemáticas: ${emptyIntermediatePages.map(r => r.page).join(', ')}`);
                console.error(`   Esto indica un problema en la API o conectividad durante la descarga.`);
            }
        }

        //console.log(`📊 ${connectionPrefix} RESULTADO FINAL DETALLADO:`, {
        //    paginas_exitosas: successfulResults.length,
        //    paginas_fallidas: failedResults.length,
        //    paginas_recuperadas: recoveredResults.length,
        //    llamadas_api_totales: totalApiCallsMade,
        //    llamadas_planificadas: totalCallsPlanned,
        //    registros_obtenidos: accumulatedData.length,
        //    registros_esperados: totalRecordsFromAPI,
        //    completitud: completenessPercentage.toFixed(2) + '%',
        //    es_completo: isComplete,
        //    ratio_recuperacion: recoveredResults.length > 0 ? `${recoveredResults.length}/${successfulResults.length}` : '0/0'
        //});

        // ✅ FINALIZACIÓN MEJORADA
        if (isComplete || accumulatedData.length > 0) {
            if (isComplete) {
                //console.log(`✅ ${connectionPrefix} DESCARGA COMPLETA: ${accumulatedData.length}/${totalRecordsFromAPI} registros`);
            } else {
                //console.log(`🔶 ${connectionPrefix} DESCARGA PARCIAL PERO UTILIZABLE: ${accumulatedData.length}/${totalRecordsFromAPI} registros`);
            }

            paginador.editarDatos([...accumulatedData]);
            paginador.editarDatosCargados(accumulatedData.length);
            paginador.editarProgresoCargado(Math.round(completenessPercentage));
            paginador.editarCargaCompletada(true);
            paginador.editarCargando(false);

            if (!isComplete && failedResults.length > 0) {
                paginador.editarError(`Descarga parcial: ${failedResults.length} páginas fallaron. ${accumulatedData.length}/${totalRecordsFromAPI} registros obtenidos.`);
            }

            if (onPartialData) {
                //console.log(`📤 ${connectionPrefix} Enviando datos finales: ${accumulatedData.length} registros`);
                const message = isComplete ? null : `Datos parciales: ${failedResults.length} páginas fallaron después de 5 reintentos`;
                onPartialData([...accumulatedData], Math.round(completenessPercentage), message);
            }
        } else {
            console.error(`💀 ${connectionPrefix} DESCARGA FALLIDA: Solo ${accumulatedData.length} registros obtenidos`);
            paginador.editarError(`Descarga fallida: ${failedResults.length}/${totalCallsPlanned} páginas fallaron completamente`);
            paginador.editarCargando(false);
        }

        if (onMetricsUpdate) {
            onMetricsUpdate({
                connectionId, // ✅ INCLUIR IDENTIFICADOR DE CONEXIÓN
                searchEndTime: Date.now(),
                downloadProgress: Math.round(completenessPercentage),
                finalRecordsCount: accumulatedData.length,
                totalApiCallsMade: totalApiCallsMade,
                recoveredApiCalls: recoveredCalls,
                isPartialSuccess: !isComplete && accumulatedData.length > 0,
                failedPages: failedResults.length
            });
        }

        //console.log(`🏁 ${connectionPrefix} Proceso finalizado en ${Date.now() - searchStartTime}ms con ${totalApiCallsMade} llamadas API totales`);

    } catch (error) {
        console.error(`❌ ${connectionPrefix} Error crítico en descarga:`, error);
        paginador.editarError(`Error crítico: ${error.message}`);
        paginador.editarCargando(false);

        // ✅ AHORA SÍ PUEDE ACCEDER A accumulatedData
        if (accumulatedData && accumulatedData.length > 0) {
            console.log(`💾 ${connectionPrefix} Salvando ${accumulatedData.length} registros parciales por error...`);
            paginador.editarDatos([...accumulatedData]);
            paginador.editarCargaCompletada(true);

            if (onPartialData) {
                onPartialData([...accumulatedData], 50, `Error con datos parciales: ${error.message}`);
            }
        } else if (onPartialData) {
            onPartialData([], 0, error.message);
        }
    }
};



// =====================================================================
// V4 CURSOR-BASED PAGINATION — Para reporte de Recorridos
// =====================================================================
export const cargarPaginasCursorBased = async (apiUrl, paginador, filtros, connectionId = 'Unknown', onPartialData = null, onMetricsUpdate = null) => {
    const searchStartTime = Date.now();
    let accumulatedData = [];
    let callCount = 0;
    let totalRecords = 0;
    let failedCalls = 0;
    let recoveredCalls = 0;

    const connectionPrefix = `[${connectionId}]`;
    const pageSize = 5000; // V4 permite hasta 10000
    const maxRetries = 5;

    try {
        // Inicializar estados
        paginador.editarCargando(true);
        paginador.editarCargaCompletada(false);
        paginador.editarDatos([]);
        paginador.editarProgresoCargado(0);
        paginador.editarError(null);

        // Construir payload base (sin page ni order — V4 no los usa)
        const buildPayload = (cursor, includeCount) => {
            const payload = {
                uids_vehiculo: filtros.uids_vehiculo,
                fecha_inicio: filtros.fecha_inicio,
                fecha_fin: filtros.fecha_fin,
                limit: pageSize,
                cursor: cursor
            };
            if (filtros.empresaUid) payload.empresaUid = filtros.empresaUid;
            if (filtros.empresas_seleccionadas) payload.empresas_seleccionadas = filtros.empresas_seleccionadas;
            if (filtros.tipos) payload.tipos = filtros.tipos;
            if (includeCount) payload.count = true;
            return payload;
        };

        // Función de petición con reintentos (reutiliza patrón de cargarPaginasUltraOptimizado)
        const fetchWithRetries = async (payload, retryCount = 0) => {
            const startTime = Date.now();
            const attemptNumber = retryCount + 1;

            try {
                const baseTimeout = 120000;
                const timeoutMs = baseTimeout + (retryCount * 30000);

                const response = await apiClient.post(apiUrl, payload, {
                    timeout: timeoutMs,
                    maxContentLength: 50 * 1024 * 1024,
                    maxBodyLength: 50 * 1024 * 1024
                });

                const duration = Date.now() - startTime;
                const pageData = response.data?.data?.items || [];
                const pagination = response.data?.data?.pagination || {};

                if (retryCount > 0) recoveredCalls++;

                return {
                    success: true,
                    data: pageData,
                    pagination,
                    duration,
                    attemptNumber
                };

            } catch (error) {
                const duration = Date.now() - startTime;
                console.error(`❌ ${connectionPrefix} Error llamada cursor (intento ${attemptNumber}):`, error.message);

                if (retryCount < maxRetries) {
                    const delay = Math.min(1000 * Math.pow(1.5, retryCount), 15000);
                    console.log(`🔁 ${connectionPrefix} Reintentando en ${delay}ms... (${attemptNumber}/${maxRetries})`);
                    await new Promise(resolve => setTimeout(resolve, delay));
                    return fetchWithRetries(payload, retryCount + 1);
                }

                failedCalls++;
                return { success: false, data: [], pagination: {}, duration, error: error.message };
            }
        };

        // PASO 1: Primera llamada con count:true para obtener total + datos
        console.log(`🚀 ${connectionPrefix} Iniciando carga V4 cursor-based...`);
        const firstResult = await fetchWithRetries(buildPayload(null, true));
        callCount++;

        if (!firstResult.success) {
            paginador.editarError(`Error en primera llamada: ${firstResult.error}`);
            paginador.editarCargando(false);
            if (onPartialData) onPartialData([], 0, firstResult.error);
            return;
        }

        totalRecords = firstResult.pagination.total || 0;
        accumulatedData = [...firstResult.data];
        let cursor = firstResult.pagination.nextCursor || null;
        let hasMore = firstResult.pagination.hasMore || false;

        paginador.editarTotalDatos(totalRecords);
        paginador.editarDatos([...accumulatedData]);

        const progressFromTotal = (received) => {
            if (totalRecords > 0) return Math.min(Math.round((received / totalRecords) * 100), 99);
            return Math.min(95, callCount * 10);
        };

        paginador.editarProgresoCargado(progressFromTotal(accumulatedData.length));

        // Reportar métricas iniciales
        if (onMetricsUpdate) {
            onMetricsUpdate({
                connectionId,
                startTime: searchStartTime,
                totalRecordsExpected: totalRecords,
                totalRecordsReceived: accumulatedData.length,
                downloadProgress: progressFromTotal(accumulatedData.length),
                completedApiCalls: callCount,
                totalApiCalls: totalRecords > 0 ? Math.ceil(totalRecords / pageSize) : 1,
                status: hasMore ? 'downloading' : 'completed'
            });
        }

        // PASO 2: Iterar páginas siguientes con cursor (SIN count)
        while (hasMore) {
            const result = await fetchWithRetries(buildPayload(cursor, false));
            callCount++;

            if (!result.success) {
                console.warn(`⚠️ ${connectionPrefix} Fallo en llamada ${callCount}, continuando con datos parciales...`);
                break;
            }

            if (result.data.length > 0) {
                accumulatedData = [...accumulatedData, ...result.data];
            }

            cursor = result.pagination.nextCursor || null;
            hasMore = result.pagination.hasMore || false;

            // Actualizar paginador
            const progress = progressFromTotal(accumulatedData.length);
            paginador.editarDatos([...accumulatedData]);
            paginador.editarProgresoCargado(progress);
            paginador.editarDatosCargados(accumulatedData.length);

            // Reportar métricas
            if (onMetricsUpdate) {
                onMetricsUpdate({
                    connectionId,
                    totalRecordsReceived: accumulatedData.length,
                    totalRecordsExpected: totalRecords,
                    downloadProgress: progress,
                    completedApiCalls: callCount,
                    failedApiCalls: failedCalls,
                    recoveredApiCalls: recoveredCalls,
                    status: hasMore ? 'downloading' : 'completed',
                    apiCallsHistory: [{
                        type: 'CURSOR',
                        duration: result.duration,
                        success: true,
                        recovered: result.attemptNumber > 1,
                        attemptNumber: result.attemptNumber,
                        timestamp: Date.now(),
                        records: result.data.length
                    }]
                });
            }

            // Datos parciales
            if (onPartialData) {
                onPartialData([...accumulatedData], progress);
            }
        }

        // PASO 3: Finalizar
        paginador.editarDatos(accumulatedData);
        paginador.editarCargando(false);
        paginador.editarCargaCompletada(true);
        paginador.editarProgresoCargado(100);
        paginador.editarDatosCargados(accumulatedData.length);

        const totalTime = Date.now() - searchStartTime;
        console.log(`✅ ${connectionPrefix} Carga V4 completada: ${accumulatedData.length} registros en ${callCount} llamadas (${Math.round(totalTime / 1000)}s)`);

        if (onMetricsUpdate) {
            onMetricsUpdate({
                connectionId,
                searchEndTime: Date.now(),
                downloadProgress: 100,
                totalRecordsReceived: accumulatedData.length,
                totalRecordsExpected: totalRecords,
                completedApiCalls: callCount,
                failedApiCalls: failedCalls,
                recoveredApiCalls: recoveredCalls,
                status: 'completed',
                endTime: Date.now()
            });
        }

        if (onPartialData) onPartialData(accumulatedData, 100);

    } catch (error) {
        console.error(`❌ ${connectionPrefix} Error crítico en carga V4:`, error.message);
        paginador.editarError(`Error crítico: ${error.message}`);
        paginador.editarCargando(false);

        if (accumulatedData.length > 0) {
            console.log(`💾 ${connectionPrefix} Salvando ${accumulatedData.length} registros parciales...`);
            paginador.editarDatos([...accumulatedData]);
            paginador.editarCargaCompletada(true);
        }

        if (onPartialData) onPartialData([...accumulatedData], 0, error.message);
    }
};

// =====================================================================
// V3 DISTANCE — Para reporte de Kilómetros
// =====================================================================
export const cargarDistanciaVehiculos = async (apiUrl, paginador, filtros, connectionId = 'Distance', onMetricsUpdate = null) => {
    const searchStartTime = Date.now();
    const connectionPrefix = `[${connectionId}]`;
    const maxRetries = 3;

    try {
        // Inicializar estados
        paginador.editarCargando(true);
        paginador.editarCargaCompletada(false);
        paginador.editarDatos([]);
        paginador.editarProgresoCargado(0);
        paginador.editarError(null);

        // Construir payload para /distance
        const payload = {
            uids_vehiculo: filtros.uids_vehiculo,
            fecha_inicio: filtros.fecha_inicio,
            fecha_fin: filtros.fecha_fin,
            page: 1,
            limit: 3000 // máximo permitido por el endpoint
        };
        if (filtros.empresaUid) payload.empresaUid = filtros.empresaUid;
        if (filtros.empresas_seleccionadas) payload.empresas_seleccionadas = filtros.empresas_seleccionadas;

        console.log(`🚀 ${connectionPrefix} Iniciando carga Distance...`);
        paginador.editarProgresoCargado(10);

        if (onMetricsUpdate) {
            onMetricsUpdate({
                connectionId,
                startTime: searchStartTime,
                status: 'downloading',
                downloadProgress: 10
            });
        }

        // Llamar endpoint con reintentos
        let lastError = null;
        let response = null;

        // Timeout escala según cantidad de vehículos:
        // ≤10 vehículos: 120s, ≤100: 180s, ≤500: 240s, >500: 300s
        const vehicleCount = payload.uids_vehiculo?.length || 1;
        const baseTimeout = vehicleCount <= 10 ? 120000 : vehicleCount <= 100 ? 180000 : vehicleCount <= 500 ? 240000 : 300000;

        for (let attempt = 0; attempt <= maxRetries; attempt++) {
            try {
                const timeoutMs = baseTimeout + (attempt * 60000); // +60s por reintento
                console.log(`🔄 ${connectionPrefix} Intento ${attempt + 1}/${maxRetries + 1} (timeout: ${Math.round(timeoutMs / 1000)}s, ${vehicleCount} vehículos)`);
                response = await apiClient.post(apiUrl, payload, {
                    timeout: timeoutMs,
                    maxContentLength: 50 * 1024 * 1024,
                    maxBodyLength: 50 * 1024 * 1024
                });
                break; // Éxito
            } catch (error) {
                lastError = error;
                console.error(`❌ ${connectionPrefix} Error intento ${attempt + 1}/${maxRetries + 1}:`, error.message);
                if (attempt < maxRetries) {
                    const delay = Math.min(2000 * Math.pow(1.5, attempt), 15000);
                    await new Promise(resolve => setTimeout(resolve, delay));
                }
            }
        }

        if (!response) {
            const errorMsg = lastError?.message || 'Error desconocido en endpoint distance';
            paginador.editarError(errorMsg);
            paginador.editarCargando(false);
            if (onMetricsUpdate) {
                onMetricsUpdate({ connectionId, status: 'failed', downloadProgress: 0, endTime: Date.now() });
            }
            return;
        }

        // Verificar errores en la respuesta
        if (response.data?.statusCode && response.data.statusCode !== 200) {
            const errorMsg = response.data?.message || 'Error en respuesta del servidor';
            paginador.editarError(errorMsg);
            paginador.editarCargando(false);
            return;
        }

        paginador.editarProgresoCargado(60);

        // Parsear respuesta: response.data.data.vehiculos[]
        let vehiculos = response.data?.data?.vehiculos || [];
        const pagination = response.data?.data?.pagination;
        const resumen = response.data?.data?.resumen;

        // Si hay más páginas (>3000 vehículos, muy raro)
        if (pagination?.hasNextPage) {
            let page = 2;
            while (true) {
                try {
                    const nextResponse = await apiClient.post(apiUrl, { ...payload, page }, {
                        timeout: 120000
                    });
                    const nextVehiculos = nextResponse.data?.data?.vehiculos || [];
                    if (nextVehiculos.length === 0) break;
                    vehiculos = [...vehiculos, ...nextVehiculos];
                    const nextPagination = nextResponse.data?.data?.pagination;
                    if (!nextPagination?.hasNextPage) break;
                    page++;
                } catch (error) {
                    console.warn(`⚠️ ${connectionPrefix} Error en página ${page}, continuando con datos parciales`);
                    break;
                }
            }
        }

        paginador.editarProgresoCargado(90);

        // Guardar datos en paginador (array de vehículos con sus días)
        paginador.editarDatos(vehiculos);
        paginador.editarCargando(false);
        paginador.editarCargaCompletada(true);
        paginador.editarProgresoCargado(100);
        paginador.editarTotalDatos(vehiculos.length);
        paginador.editarDatosCargados(vehiculos.length);

        const totalTime = Date.now() - searchStartTime;
        console.log(`✅ ${connectionPrefix} Carga Distance completada: ${vehiculos.length} vehículos (${Math.round(totalTime / 1000)}s)`);
        if (resumen) {
            console.log(`📊 ${connectionPrefix} Resumen: ${resumen.totalVehiculos} vehículos, ${resumen.distanciaTotalFlota?.toFixed(2)} km total, ${resumen.tiempoProcesamiento}`);
        }

        if (onMetricsUpdate) {
            onMetricsUpdate({
                connectionId,
                downloadProgress: 100,
                totalRecordsReceived: vehiculos.length,
                totalRecordsExpected: vehiculos.length,
                status: 'completed',
                endTime: Date.now()
            });
        }

    } catch (error) {
        console.error(`❌ ${connectionPrefix} Error crítico en carga Distance:`, error.message);
        paginador.editarError(`Error crítico: ${error.message}`);
        paginador.editarCargando(false);

        if (onMetricsUpdate) {
            onMetricsUpdate({ connectionId, status: 'failed', downloadProgress: 0, endTime: Date.now() });
        }
    }
};

// =====================================================================
// V3 DISTANCE SSE STREAMING — Para reporte de Kilómetros con muchos vehículos
// Soporta: heartbeat keepalive, event IDs, abort on disconnect,
//          chunks fallidos parciales, datos progresivos.
// Si SSE falla, lanza error para que el caller haga fallback a /distance.
// =====================================================================
export const cargarDistanciaVehiculosStream = async (apiUrl, paginador, filtros, connectionId = 'DistanceSSE', onMetricsUpdate = null, abortSignal = null) => {
    const searchStartTime = Date.now();
    const connectionPrefix = `[${connectionId}]`;

    // Construir payload (idéntico a /distance)
    const payload = {
        uids_vehiculo: filtros.uids_vehiculo,
        fecha_inicio: filtros.fecha_inicio,
        fecha_fin: filtros.fecha_fin
    };
    if (filtros.empresaUid) payload.empresaUid = filtros.empresaUid;
    if (filtros.empresas_seleccionadas) payload.empresas_seleccionadas = filtros.empresas_seleccionadas;

    const vehicleCount = payload.uids_vehiculo?.length || 0;
    console.log(`🚀 ${connectionPrefix} Iniciando carga Distance SSE (${vehicleCount} vehículos)...`);

    // Obtener token de autenticación (mismo que usa apiClientAlertas)
    const token = localStorage.getItem('token');
    const headers = {
        'Content-Type': 'application/json'
    };
    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }

    // Verificar que la URL está configurada
    if (!apiUrl) {
        throw new Error('SSE: URL no configurada (REACT_APP_VEHICLE_DISTANCE_STREAM_URL). Reinicia el dev server después de modificar .env');
    }

    console.log(`📡 ${connectionPrefix} Conectando a: ${apiUrl}`);

    // Configurar fetch con signal para poder cancelar
    const fetchOptions = {
        method: 'POST',
        headers,
        body: JSON.stringify(payload)
    };
    if (abortSignal) {
        fetchOptions.signal = abortSignal;
    }

    const response = await fetch(apiUrl, fetchOptions);

    if (!response.ok) {
        const errorText = await response.text().catch(() => '');
        throw new Error(`SSE HTTP ${response.status}: ${errorText}`);
    }

    // Verificar que la respuesta es un stream
    if (!response.body) {
        throw new Error('SSE: response.body no disponible (streaming no soportado)');
    }

    const contentType = response.headers.get('content-type') || '';
    if (!contentType.includes('text/event-stream')) {
        console.warn(`⚠️ ${connectionPrefix} Content-Type inesperado: ${contentType} (esperado text/event-stream)`);
    }

    console.log(`📡 ${connectionPrefix} Conexión SSE establecida, leyendo stream...`);

    // Leer el stream SSE
    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';
    let accumulatedVehiculos = [];
    let resumenFinal = null;
    let totalFailedChunks = 0;
    let receivedAnyData = false;

    try {
        while (true) {
            const { done, value } = await reader.read();
            if (done) break;

            buffer += decoder.decode(value, { stream: true });
            const lines = buffer.split('\n');
            buffer = lines.pop();

            let currentEvent = '';
            for (const line of lines) {
                if (line.trim() === '') { currentEvent = ''; continue; }
                if (line.startsWith(':')) { continue; }       // Heartbeat keepalive
                if (line.startsWith('id:')) { continue; }     // Event IDs

                if (line.startsWith('event: ')) {
                    currentEvent = line.slice(7).trim();
                    continue;
                }

                if (line.startsWith('data: ') && currentEvent) {
                    try {
                        const data = JSON.parse(line.slice(6));
                        receivedAnyData = true;

                        switch (currentEvent) {
                            case 'progress': {
                                console.log(`📊 ${connectionPrefix} Inicio: ${data.totalVehiculos} veh, ${data.totalBatches} lotes, ${data.totalDays} días, ~${(data.estimatedRecords / 1000000).toFixed(1)}M registros`);
                                paginador.editarTotalDatos(data.totalVehiculos);
                                if (onMetricsUpdate) {
                                    onMetricsUpdate({ connectionId, totalRecordsExpected: data.totalVehiculos, totalApiCalls: data.totalBatches, downloadProgress: 5, status: 'downloading' });
                                }
                                break;
                            }
                            case 'data': {
                                const loteVehiculos = data.vehiculos || [];
                                const progress = data.progress || {};
                                accumulatedVehiculos = [...accumulatedVehiculos, ...loteVehiculos];

                                if (progress.failedChunks > 0) {
                                    totalFailedChunks += progress.failedChunks;
                                    console.warn(`⚠️ ${connectionPrefix} Lote ${progress.completedBatches}: ${progress.failedChunks} chunks fallidos`);
                                }

                                const percent = progress.percent || Math.round((accumulatedVehiculos.length / vehicleCount) * 100);
                                console.log(`📦 ${connectionPrefix} Lote ${progress.completedBatches}/${progress.totalBatches}: +${loteVehiculos.length} veh (${accumulatedVehiculos.length} total, ${percent}%) ${progress.batchTime ? `[${progress.batchTime}]` : ''}`);

                                paginador.editarDatos([...accumulatedVehiculos]);
                                paginador.editarProgresoCargado(Math.min(percent, 99));
                                paginador.editarDatosCargados(accumulatedVehiculos.length);

                                if (onMetricsUpdate) {
                                    onMetricsUpdate({
                                        connectionId, totalRecordsReceived: accumulatedVehiculos.length,
                                        totalRecordsExpected: progress.totalVehiculos || vehicleCount,
                                        downloadProgress: percent, completedApiCalls: progress.completedBatches,
                                        totalApiCalls: progress.totalBatches, failedApiCalls: totalFailedChunks,
                                        status: 'downloading'
                                    });
                                }
                                break;
                            }
                            case 'done': {
                                resumenFinal = data.resumen || data;
                                console.log(`✅ ${connectionPrefix} Stream completado: ${resumenFinal.totalVehiculos} veh, ${resumenFinal.distanciaTotalFlota?.toFixed(2)} km, ${resumenFinal.tiempoProcesamiento}`);
                                break;
                            }
                            case 'error': {
                                console.error(`❌ ${connectionPrefix} Error del servidor:`, data.message);
                                if (accumulatedVehiculos.length === 0) {
                                    paginador.editarError(`Error del servidor: ${data.message}`);
                                }
                                break;
                            }
                        }
                    } catch (parseError) {
                        console.warn(`⚠️ ${connectionPrefix} Error parseando SSE:`, parseError.message);
                    }
                    currentEvent = '';
                }
            }
        }
    } finally {
        try { reader.cancel(); } catch (e) { /* ignore */ }
    }

    // Si no recibimos ningún dato, lanzar error para que el caller haga fallback
    if (!receivedAnyData && accumulatedVehiculos.length === 0) {
        throw new Error('SSE: Stream cerrado sin recibir datos');
    }

    // Finalizar
    paginador.editarDatos(accumulatedVehiculos);
    paginador.editarCargando(false);
    paginador.editarCargaCompletada(true);
    paginador.editarProgresoCargado(100);
    paginador.editarTotalDatos(accumulatedVehiculos.length);
    paginador.editarDatosCargados(accumulatedVehiculos.length);

    const totalTime = Date.now() - searchStartTime;
    console.log(`🏁 ${connectionPrefix} SSE finalizado: ${accumulatedVehiculos.length} veh en ${Math.round(totalTime / 1000)}s${totalFailedChunks > 0 ? ` (${totalFailedChunks} chunks fallidos)` : ''}`);

    if (onMetricsUpdate) {
        onMetricsUpdate({ connectionId, downloadProgress: 100, totalRecordsReceived: accumulatedVehiculos.length, status: 'completed', endTime: Date.now() });
    }
};


// Exportamos las funciones públicas
export { cargarPaginas, cargarPaginasConMetricas, limpiarCache };
export default cargarPaginas;